<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image3" /> -->
    <transition appear @before-enter="$animations.beforeEnterLogoArea" @enter="$animations.enterLogoArea">
      <Logo></Logo>
    </transition>

    <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
      <div class="columns is-centered">
        <div v-if="$root.selectedLanguage === `en`" class="column" style="text-align: center">
          <img src="../assets/images/icons/updatedIcons/normalFlow/personalInfo.png" alt="paymedia-logo" width="85%" />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img src="../assets/images/icons/RDBheaderimages/Group 289342.png" alt="paymedia-logo" width="85%" />
        </div>
      </div>
    </transition>
    <div class=" card is-centered px-4" style="width: 80%; margin: auto ">
      <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
        <div class="columns is-centered">
          <div class="column is-full ps-5" style="text-align: center">
            <img src="../assets/images/icons/Blue/Group 158.png" alt="contact-info-img" width="70" height="70" />
            <p :class="`text-center mx-3 mb-2  texthead ${$root.selectedLanguage === `ta`
                ? `ta-he-line`
                : $root.selectedLanguage === `si`
                  ? `si-he-line`
                  : `en-he-line`
              }`"
               style="font-family: OpenSans-Bold ;">

              {{ $root.selectedLanguageData.personalInformation }}
            </p>
            <p :class="`${$root.selectedLanguage === `ta`
                ? `ta-sub-line`
                : $root.selectedLanguage === `si`
                  ? `si-sub-line`
                  : `en-sub-line`
              }`"
               style="font-family: OpenSans-Bold ;">
              {{ $root.selectedLanguageData.tellUsMoreAboutYou }}
            </p>
            <p style="font-family: OpenSans-Regular ;">
              {{ $root.selectedLanguageData.dataEditByButton }}
            </p>
          </div>
        </div>
      </transition>

<!--      v-slot="{ invalid }"-->
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="onSubmit">
          <transition appear @before-enter="$animations.beforeEnterBelow" @enter="$animations.enterBelow">
            <div class="columns is-centered">
              <div class="column is-three-quarters pt-5 ps-5">

                <!--title and surname-->
                <div class="columns is-7 is-variable" :key="1">
                  <div class="column is-one-quarter">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.title }}
                      <span class="has-text-danger">*</span>
                    </label>
                    <ValidationProvider name="your name title" :rules="{ required: true }" v-slot="{ errors }">
                      <div>
                        <b-select
                            @focus="$inputFocused('title')"
                            @input="$inputChanged('title')"
                            @blur="$inputBlured('title')"
                            v-model="$root.formData.title">
<!--                          <option value="Master" v-if="$root.formData.account_name !=='RDB Liya Saviya' || $root.formData.account_name !=='RDB Liya Saviya Plus' " >
                            {{ $root.selectedLanguageData.master }}
                          </option>-->
                          <option value="Mr"  v-if="$root.formData.account_name !=='RDB Liya Saviya' || $root.formData.account_name !=='RDB Liya Saviya Plus' ">
                            {{ $root.selectedLanguageData.mr }}
                          </option>
                          <option value="Mrs" >
                            {{ $root.selectedLanguageData.mrs }}
                          </option>
                          <option value="Ms">
                            {{ $root.selectedLanguageData.ms }}
                          </option>
                          <option value="Miss">
                            {{ $root.selectedLanguageData.miss }}
                          </option>
                          <option value="Dr">
                            {{ $root.selectedLanguageData.dr }}
                          </option>
                          <option value="Professor">
                            {{ $root.selectedLanguageData.professor }}
                          </option>
                          <option value="Rev">
                            {{ $root.selectedLanguageData.rev }}
                          </option>
                        </b-select>
                      </div>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="column">
                    <label :class="`${ $root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.surname }}
                      <span class="has-text-danger">*</span>
                    </label>
                    <div class="field">
                      <p class="control has-icons-right">
                        <ValidationProvider name="Surname" :rules="validateFullName()" v-slot="{ errors }">
                          <b-input type="text" v-model="$root.formData.surname"
                              @focus="$inputFocused('surname')"
                              @input="() => {$inputChanged('surname');}"
                              @blur="$inputBlured('surname')"
                          />
                          <span class="icon is-small is-right">
                        <img
                            src="../assets/images/icons/Blue/Group 158.png"
                            alt="contact-name-img"
                            width="25"
                            height="25"
                        />
                      </span>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </p>
                    </div>
                  </div>
                </div>

                <!--other name-->
                <div :key="2">
                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                    {{ $root.selectedLanguageData.otherName }}
                    <span class="has-text-danger">*</span>
                  </label>
                  <b-field>
                    <p class="control has-icons-right">
                      <ValidationProvider
                          name="Other Name"
                          :rules="validateOtherName()"
                          v-slot="{ errors }">
                        <b-input type="text"
                            v-model="$root.formData.other_name"
                            @focus="$inputFocused('other_name')"
                            @input="() => {$inputChanged('other_name');}"
                            @blur="$inputBlured('other_name')"/>
                        <span class="icon is-small is-right mr-2">
                      <img
                          src="../assets/images/icons/Blue/Group 158.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                      />
                    </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </b-field>
                </div>

                <!-- Gender -->
                <div class="field mt-4">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.gender}}
                    <span class="has-text-danger">*</span>
                  </label>

                  <div class="columns">
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio
                              disabled
                              name="gender" style="font-family: OpenSans-Regular" native-value="Male"
                                   @focus="$inputFocused('gender')" @input="$inputChanged('gender')"
                                   @blur="$inputBlured('gender')" v-model="$root.formData.gender">
                            {{$root.selectedLanguageData.male }}
                          </b-radio>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio disabled name="gender" style="font-family: OpenSans-Regular" native-value="Female"
                                   @focus="$inputFocused('gender')" @input="$inputChanged('gender')"
                                   @blur="$inputBlured('gender')" v-model="$root.formData.gender">
                            {{ $root.selectedLanguageData.female }}
                          </b-radio>
                          <span class="has-text-danger">{{errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>

<!--                    <div class="column is-one-quarter">-->
<!--                      <b-field>-->
<!--                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                          <b-radio name="gender" style="font-family: fira400" native-value="Other"-->
<!--                                   @focus="$inputFocused('gender')" @input="$inputChanged('gender')"-->
<!--                                   @blur="$inputBlured('gender')" v-model="$root.formData.gender">-->
<!--                            {{ $root.selectedLanguageData.other }}-->
<!--                          </b-radio>-->
<!--                          <span class="has-text-danger">{{errors[0] }}</span>-->
<!--                        </ValidationProvider>-->
<!--                      </b-field>-->
<!--                    </div>-->
                  </div>
                </div>

                <!-- marital status -->
                <div class="field mt-4">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.maritalStatus}}
                    <span class="has-text-danger">*</span>
                  </label>

                  <div class="columns">
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="marital_status" style="font-family: OpenSans-Regular" native-value="Married"
                                   @focus="$inputFocused('marital_status')" @input="$inputChanged('marital_status')"
                                   @blur="$inputBlured('marital_status')" v-model="$root.formData.marital_status">
                            {{$root.selectedLanguageData.married }}
                          </b-radio>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="marital_status" style="font-family: OpenSans-Regular" native-value="Unmarried"
                                   @focus="$inputFocused('marital_status')" @input="$inputChanged('marital_status')"
                                   @blur="$inputBlured('marital_status')" v-model="$root.formData.marital_status"
                                   @click.native="$root.formData.spouse_name =''">
                            {{ $root.selectedLanguageData.unmarried }}
                          </b-radio>
                          <span class="has-text-danger">{{errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>

                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="marital_status" style="font-family: OpenSans-Regular" native-value="Other"
                                   @focus="$inputFocused('marital_status')" @input="$inputChanged('marital_status')"
                                   @blur="$inputBlured('marital_status')" v-model="$root.formData.marital_status"
                          @click.native="$root.formData.spouse_name =''">
                            {{ $root.selectedLanguageData.other }}
                          </b-radio>
                          <span class="has-text-danger">{{errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                  </div>
                </div>

                <!-- spouse name -->
                <div  v-if=" $root.formData.marital_status === `Married`">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.spouse_name }}
                    <span class="has-text-danger">*</span>
                  </label>
                    <b-field>
                      <ValidationProvider name="Name" :rules="spouseFullName()" v-slot="{ errors }">
                        <b-input type="text" @focus="$inputFocused('spouse_name')" @input="$inputChanged('spouse_name') "
                                 @blur="$inputBlured('spouse_name')" v-model="$root.formData.spouse_name" />
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                </div>
                <!-- residence select start -->
                <div class="field mt-4  ">

                  <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.residency
                    }}<span class="has-text-danger">*</span></label>
                  <div class="columns">
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="residence" style="font-family: OpenSans-Regular" native-value="Resident in Sri Lanka"
                                   @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"
                                   @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"
                                   @click.native="countrySelect(`Sri Lanka`)"
                          >
                            {{
                              $root.selectedLanguageData.residentInSriLanka
                            }} </b-radio><span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="residence" style="font-family: OpenSans-Regular" native-value="Non Resident"
                                   @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"
                                   @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"
                                   @click.native="countrySelect(`Non Resident`)">
                            {{ $root.selectedLanguageData.nonResident }} </b-radio><span class="has-text-danger">{{
                            errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                  </div>
                </div>
                <!-- residence select end-->
                <div v-if="
                  $root.formData.residentship ===
                  `Non Resident` ">
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
                      {{
                        $root.selectedLanguageData
                            .specifyTheCountry
                      }}<span class="has-text-danger">*</span></label>

                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('resident_country')"
                                    @input="$inputChanged('resident_country')"
                                    @blur="$inputBlured('resident_country')" v-model="$root.formData.resident_country"
                                    expanded>
                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <!-- Citizenship select start here -->
                <div class="mb-5 mt-4"> <!-- (v-if="$root.kycFieldVisibility.citizenship") need to add -->
                  <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                    {{ $root.selectedLanguageData.nationalityCitizenship
                    }}<span class="has-text-danger">*</span></label>
                  <div style="width: 100%">
                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <b-select style="width: 100%" expanded v-model="$root.formData.citizenship"
                                @focus="$inputFocused('citizenship')" @input="
                        () => {
                          $inputChanged('citizenship');
                          dualCitizenCounties();
                          if($root.formData.citizenship !== 'Sri Lankan with Dual Citizenship'){
                            $root.formData.citizenship_country = ''
                          }
                        }
                      " @blur="$inputBlured('citizenship')">
                        <option value="Sri Lankan">
                          {{ $root.selectedLanguageData.srilanka }}
                        </option>
                        <option value="Sri Lankan with Dual Citizenship">
                          {{
                            $root.selectedLanguageData
                                .sriLankanWithDualCitizenship
                          }}
                        </option>

                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- Citizenship select end here -->

<!--                if citizenship is dual-->
                <div v-if="$root.formData.citizenship === 'Sri Lankan with Dual Citizenship'">
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
                      {{
                        $root.selectedLanguageData
                            .specifyTheCountry
                      }}<span class="has-text-danger">*</span></label>

<!--                    citizenship country-->
                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('citizenship_country')"
                                    @input="$inputChanged('citizenship_country')"
                                    @blur="$inputBlured('citizenship_country')" v-model="$root.formData.citizenship_country"
                                    expanded>
                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>





                <!-- residence select start -->
<!--                              <div class="field  ">-->

<!--                                <label :class="`${$root.selectedLanguage === `ta`-->
<!--                                  ? `ta-label`-->
<!--                                  : $root.selectedLanguage === `si`-->
<!--                                    ? `si-label`-->
<!--                                    : ``-->
<!--                                  }`">{{ $root.selectedLanguageData.residency-->
<!--                  }}<span class="has-text-danger">*</span></label>-->
<!--                                <div class="columns">-->
<!--                                  <div class="column is-one-two">-->
<!--                                    <b-field>-->
<!--                                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                        <b-radio name="residence" style="font-family: fira400" native-value="Resident in Sri Lanka"-->
<!--                                          @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"-->
<!--                                          @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"-->
<!--                                          @click.native="countrySelect(`Sri Lanka`)">-->
<!--                                          {{-->
<!--                                            $root.selectedLanguageData.residentInSriLanka-->
<!--                                          }} </b-radio><span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                                      </ValidationProvider>-->
<!--                                    </b-field>-->
<!--                                  </div>-->
<!--                                  <div class="column is-8">-->
<!--                                    <b-field>-->
<!--                                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                        <b-radio name="residence" style="font-family: fira400" native-value="Non Resident"-->
<!--                                          @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"-->
<!--                                          @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"-->
<!--                                          @click.native="countrySelect(``)">-->
<!--                                          {{ $root.selectedLanguageData.nonResident }} </b-radio><span class="has-text-danger">{{-->
<!--                                            errors[0] }}</span>-->
<!--                                      </ValidationProvider>-->
<!--                                    </b-field>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
                <!-- residence select end-->

                <!-- select country start here -->
<!--                              <div v-if="$root.formData.residentship === `Non Resident`">-->
<!--                                <div>-->
<!--                                  <label :class="`${$root.selectedLanguage === `ta`-->
<!--                                    ? `ta-label`-->
<!--                                    : $root.selectedLanguage === `si`-->
<!--                                      ? `si-label`-->
<!--                                      : ``-->
<!--                                    }`">{{-->
<!--                    $root.selectedLanguageData-->
<!--                      .please_select_the_country_of_residence-->
<!--                  }}<span class="has-text-danger">*</span></label>-->

<!--                                  <div>-->
<!--                                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                      <div style="width: 100%">-->
<!--                                        <b-select @focus="$inputFocused('resident_countries')"-->
<!--                                          @input="$inputChanged('resident_countries')" @blur="$inputBlured('resident_countries')"-->
<!--                                          v-model="$root.formData.resident_countries" expanded>-->
<!--                                          <option v-for="country in countriesArray" :key="country.value" :value="country.value">-->
<!--                                            {{ country.countryName }}-->
<!--                                          </option>-->
<!--                                        </b-select>-->
<!--                                      </div>-->
<!--                                      <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                                    </ValidationProvider>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->

<!--                              <div v-if="-->
<!--                                  $root.formData.residentship ===-->
<!--                                  `Non Resident` ">-->
<!--                                <div>-->
<!--                                  <label :class="`${$root.selectedLanguage === `ta`-->
<!--                                        ? `ta-label`-->
<!--                                        : $root.selectedLanguage === `si`-->
<!--                                          ? `si-label`-->
<!--                                          : ``-->
<!--                                      }`">-->
<!--                                    {{-->
<!--                                      $root.selectedLanguageData-->
<!--                                          .specifyTheCountry-->
<!--                                    }}<span class="has-text-danger">*</span></label>-->

<!--                                  <div>-->
<!--                                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                      <div style="width: 100%">-->
<!--                                        <b-select @focus="$inputFocused('resident_country')"-->
<!--                                                  @input="$inputChanged('resident_country')"-->
<!--                                                  @blur="$inputBlured('resident_country')" v-model="$root.formData.resident_country"-->
<!--                                                  expanded>-->
<!--                                          <option v-for="country in countriesArray" :key="country.value" :value="country.value">-->
<!--                                            {{ country.countryName }}-->
<!--                                          </option>-->
<!--                                        </b-select>-->
<!--                                      </div>-->
<!--                                      <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                                    </ValidationProvider>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                &lt;!&ndash; select country end here &ndash;&gt;-->

<!--                &lt;!&ndash; Citizenship select start here &ndash;&gt;-->
<!--                              <div class="mb-5 mt-4"> &lt;!&ndash; (v-if="$root.kycFieldVisibility.citizenship") need to add &ndash;&gt;-->
<!--                                <label :class="`${$root.selectedLanguage === `ta`-->
<!--                                  ? `ta-label`-->
<!--                                  : $root.selectedLanguage === `si`-->
<!--                                    ? `si-label`-->
<!--                                    : ``-->
<!--                                  }`">-->
<!--                                  {{ $root.selectedLanguageData.nationalityCitizenship-->
<!--                                  }}<span class="has-text-danger">*</span></label>-->
<!--                                <div style="width: 100%">-->
<!--                                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                    <b-select style="width: 100%" expanded v-model="$root.formData.citizenship"-->
<!--                                      @focus="$inputFocused('citizenship')" @input="-->
<!--                                        () => {-->
<!--                                          $inputChanged('citizenship');-->
<!--                                          dualCitizenCounties();-->
<!--                                        }-->
<!--                                      " @blur="$inputBlured('citizenship')">-->
<!--                                      <option value="Sri Lankan">-->
<!--                                        {{ $root.selectedLanguageData.srilanka }}-->
<!--                                      </option>-->
<!--                                      <option value="Sri Lankan with Dual Citizenship">-->
<!--                                        {{-->
<!--                                          $root.selectedLanguageData-->
<!--                                            .sriLankanWithDualCitizenship-->
<!--                                        }}-->
<!--                                      </option>-->
<!--                <option value="Foreign National">-->
<!--                  {{ $root.selectedLanguageData.foreignNational }}-->
<!--                </option>-->
<!--                <option value="Foreign National with Dual Citizenship">-->
<!--                  {{-->
<!--                    $root.selectedLanguageData-->
<!--                      .foreignNationalWithDualCitizenship-->
<!--                  }}-->
<!--                </option>-->
<!--                                    </b-select>-->
<!--                                    <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                                  </ValidationProvider>-->
<!--                                </div>-->
<!--                              </div>-->
                <!-- Citizenship select here here -->






                <!--nic number & driving licence-->
                <div class="field mt-4">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.nic_number}}
                        <span class="has-text-danger">*</span>
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <ValidationProvider name="NIC Number" :rules="{ required: true,multiRegex: [/^([0-9]{9}[Xx||Vv])$/, /^[0-9]{12}$/],}" v-slot="{ errors }">
                            <b-input disabled type="text" @focus="$inputFocused('customer_nic')" @input="splitNic()"
                                     @blur="$inputBlured('customer_nic')" v-model="$root.formData.customer_nic" />
                            <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.driving_licence}}
<!--                        <span class="has-text-danger">*</span>-->
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <ValidationProvider name="Driving Licence"  v-slot="{ errors }">
                            <b-input type="text" @focus="$inputFocused('account_holder_driving_licence')" @input="$inputChanged('account_holder_driving_licence')"
                                     @blur="$inputBlured('account_holder_driving_licence')" v-model="$root.formData.account_holder_driving_licence" />
                            <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>

                <!--passport number & passport issue date-->
                <div class="field mt-4">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_no}}
                        <span class="has-text-danger" v-if="$root.formData.residentship === 'Non Resident'">*</span>
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <ValidationProvider name="Passport Number" :rules=" passportValidation()" v-slot="{ errors }">
                            <b-input type="text" @focus="()=>{$inputFocused('account_holder_passport_number'); if($root.formData.account_holder_passport_number === ''){
                              $root.formData.account_holder_passport_issue_date = '';
                              $root.formData.account_holder_passport_expiry_date = '';

                            }}" @input="$inputChanged('account_holder_passport_number')"
                                     @blur="$inputBlured('account_holder_passport_number')" v-model="$root.formData.account_holder_passport_number" />
                            <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_issued_date}}
                        <span class="has-text-danger" v-if="$root.formData.residentship === 'Non Resident'">*</span>
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <ValidationProvider name="passport_issue_date" :rules="passportMandotoryValidate()"  v-slot="{ errors }">
                            <b-datepicker
                                class="date-picking"
                                icon-right="calendar-today"

                                @focus="$inputFocused('account_holder_passport_issue_date')"
                                @input="$inputChanged('account_holder_passport_issue_date'); passportExpireDateCalculator()"
                                @blur="$inputBlured('account_holder_passport_issue_date')"
                                v-model="$root.formData.account_holder_passport_issue_date"
                                :max-date="maxDate"
                                :disabled="$root.formData.account_holder_passport_number===''"
                            >
                            </b-datepicker>

                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>

                <!--passport expiry date-->
                <div class="field mt-4">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_expiry_date}}
                        <span class="has-text-danger" v-if="$root.formData.residentship === 'Non Resident'">*</span>
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <ValidationProvider name="passport_expiry_date" :rules="passportMandotoryValidate()" v-slot="{ errors }">
                            <b-datepicker
                                class="date-picking"
                                icon-right="calendar-today"
                                :disabled="$root.formData.account_holder_passport_number===''"


                                @focus="$inputFocused('account_holder_passport_expiry_date')"
                                @input="$inputChanged('account_holder_passport_expiry_date')"
                                @blur="$inputBlured('account_holder_passport_expiry_date')"
                                v-model="$root.formData.account_holder_passport_expiry_date"
                                :min-date="minDate"
                            >
                            </b-datepicker>

                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two"></div>
                  </div>
                </div>

                <hr>

                <!-- address -->
                <div class="mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.permanentAddress }}
                  </label>
                  <!--permanent address house name-->
                  <div class="mt-1">
                    <p>
                      {{ $root.selectedLanguageData.houseName }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider name="Permanent address line 1" :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('permanent_address_line1')"
                                   @input="$inputChanged('permanent_address_line1')"
                                   @blur="$inputBlured('permanent_address_line1')"
                                   v-model="$root.formData.permanent_address_line1"></b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>

                  <div class="columns is-7 is-variable mt-2">
                    <!--permanent address street name-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.streetName }}
                        <span class="has-text-danger">*</span>
                      </p>
                      <b-field>
                        <ValidationProvider name="Permanent address line 2" :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                          <p class="control has-icons-right">
                            <b-input type="text" @focus="$inputFocused('permanent_address_line2')"
                                     @input="$inputChanged('permanent_address_line2')"
                                     @blur="$inputBlured('permanent_address_line2')"
                                     v-model="$root.formData.permanent_address_line2"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <!--permanent address city-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.city }}
                        <span class="has-text-danger">*</span>
                      </p>
                      <b-field>
                        <ValidationProvider name="Permanent address line 3" :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                          <p class="control has-icons-right">
                            <b-input type="text" @focus="$inputFocused('permanent_address_line3')"
                                     @input="$inputChanged('permanent_address_line3')"
                                     @blur="$inputBlured('permanent_address_line3')"
                                     v-model="$root.formData.permanent_address_line3"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                  </div>

                  <div class="columns is-7 is-variable">
                    <!--permanent address postal code-->
                    <div class="column">
                      <p>{{ $root.selectedLanguageData.postalCode }}</p>
                      <b-field>
                        <ValidationProvider name="Permanent address postal code" :rules="{ regex: /^\d{5}$/, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('permanent_address_postal_code')"
                                   @input="$inputChanged('permanent_address_postal_code')"
                                   @blur="$inputBlured('permanent_address_postal_code')"
                                   v-model="$root.formData.permanent_address_postal_code">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <!--permanent address country-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.country }}
                        <span class="has-text-danger">*</span>
                      </p>
                      <div>
                        <ValidationProvider name="Permanent address country" :rules="{ required: true }" v-slot="{ errors }">
                          <div style="width: 100%">
                            <b-select @focus="$inputFocused('permanent_address_country')"
                                      @input="$inputChanged('permanent_address_country')"
                                      @blur="$inputBlured('permanent_address_country')"
                                      v-model="$root.formData.permanent_address_country" expanded>
                              <option v-for="country in $root.selectedLanguageData
                                .countries" :key="country.value" :value="country.value">
                                {{ country.countryName }}
                              </option>
                            </b-select>
                          </div>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- mailing Address -->
                <div class="mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                    {{ $root.selectedLanguageData.mailingAddress }}</label>
                  <b-field >
                    <b-checkbox type="is-primary" @focus="$inputFocused('mailing_address_same_as_permanent_address')"
                                @input="$inputChanged('mailing_address_same_as_permanent_address')"
                                @blur="$inputBlured('mailing_address_same_as_permanent_address')"
                                v-model="$root.formData.mailing_address_same_as_permanent_address"
                                :disabled="!$root.formData.permanent_address_line1 ||
                                !$root.formData.permanent_address_line2 ||
                                !$root.formData.permanent_address_line3 ||!
                                $root.formData.permanent_address_country"
                                @change.native="mailingAddress()"
                    >
                     <p style="font-size: 0.9rem;">{{$root.selectedLanguageData.sameAsPermanentAddress }}</p>
                    </b-checkbox>
                  </b-field>

                  <!--mailing address house name-->
                  <div class="mt-1">
                    <p>
                      {{ $root.selectedLanguageData.houseName }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider name="Mailing address line 1" :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('mailing_address_line1')"
                                   @input="$inputChanged('mailing_address_line1')"
                                   @blur="$inputBlured('mailing_address_line1')"
                                   v-model="$root.formData.mailing_address_line1"
                                   :disabled="$root.formData.mailing_address_same_as_permanent_address">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>

                  <div class="columns is-7 is-variable mt-2">
                    <!--mailing address street name-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.streetName }}
                        <span class="has-text-danger">*</span>
                      </p>
                      <b-field>
                        <ValidationProvider name="Mailing address line 2" :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                          <p class="control has-icons-right">
                            <b-input type="text" @focus="$inputFocused('mailing_address_line2')"
                                     @input="$inputChanged('mailing_address_line2')"
                                     @blur="$inputBlured('mailing_address_line2')"
                                     v-model="$root.formData.mailing_address_line2"
                                     :disabled="$root.formData.mailing_address_same_as_permanent_address">
                            </b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <!--mailing address city-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.city }}
                        <span class="has-text-danger">*</span>
                      </p>
                      <b-field>
                        <ValidationProvider name="Mailing address line 3" :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                          <p class="control has-icons-right">
                            <b-input type="text" @focus="$inputFocused('mailing_address_line3')"
                                     @input="$inputChanged('mailing_address_line3')"
                                     @blur="$inputBlured('mailing_address_line3')" v-model="$root.formData.mailing_address_line3"
                                     :disabled="$root.formData.mailing_address_same_as_permanent_address"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns is-7 is-variable">
                    <!--mailing postal code-->
                    <div class="column">
                      <p>{{ $root.selectedLanguageData.postalCode }}</p>
                      <b-field>
                        <ValidationProvider name="Mailing address postal code" :rules="{ regex: /^\d{5}$/, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('mailing_address_postal_code')"
                                   @input="$inputChanged('mailing_address_postal_code')"
                                   @blur="$inputBlured('mailing_address_postal_code')"
                                   v-model="$root.formData.mailing_address_postal_code"
                                   :disabled="$root.formData.mailing_address_same_as_permanent_address">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <!--mailing address country-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.country }}
                        <span class="has-text-danger">*</span>
                      </p>
                      <div>
                        <ValidationProvider name="Mailing address country" :rules="{ required: true }" v-slot="{ errors }">
                          <div style="width: 100%">
                            <b-select @focus="$inputFocused('mailing_address_country')"
                                      @input="$inputChanged('mailing_address_country')"
                                      @blur="$inputBlured('mailing_address_country')"
                                      v-model="$root.formData.mailing_address_country"
                                      :disabled="$root.formData.mailing_address_same_as_permanent_address" expanded>
                              <option v-for="country in $root.selectedLanguageData
                                .countries" :key="country.value" :value="country.value">
                                {{ country.countryName }}
                              </option>
                            </b-select>
                          </div>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- contactNumberResident -->
                <div class="mt-5">
                  <div class="icon-text" :style="{
                    cursor: 'pointer',
                    color: '#009ec2',
                    'line-height': '20px',
                    'text-decoration': 'underline',
                    'letter-spacing': '0.7px',
                  }">
                    <p v-if="!isShow" @click="contactNumberResidentVisible()">
                      <span class="icon has-text-info">
                        <img src="../assets/images/icons/Blue/Circle Plus.png" alt="Circle_Plus image" />
                      </span>
                      <span v-if="!isShow">{{$root.selectedLanguageData.contactNumberResident }}</span>
                    </p>
                  </div>

                  <div v-if="isShow">
                    <div v-if="isShow" @click="() => {contactNumberResidentInvisible();changeResidentialSelection(); $root.formData.residanceContactNumWithOutCode = ''; $root.formData.residenceCountryCode='+94'}" class="mb-2">

<!--                    <div class="mb-2">-->
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        <span class="icon has-text-info mr-2">
                          <img src="../assets/images/icons/Blue/Circle Minus.png"
                            alt="Circle_Mini image" />
                        </span>

                        {{ $root.selectedLanguageData.contactNumberResident }}
                      </label>
                    </div>
<!--                    </div>-->
                    <div class="columns is-7 is-variable">
                      <div class="column is-one-third">
                        <div>
                          <section>
                            <b-field>
                              <p class="control has-icons-right">
<!--                                <b-autocomplete v-model="userCode" maxlength="10" icon-pack="fi" :icon="countryIconString"-->
<!--                                                open-on-focus :data="filteredDataArr" @input="() => {++countOne;-->
<!--                                                if (countOne === 1) {-->
<!--                                                  $root.formData.countryCodeForResidentialContactNum = ``;-->
<!--                                                  isResidentCountryCodeTouched = true;-->
<!--                                                }}"-->
<!--                                                @select="(option) => {-->
<!--                                                if (option) {-->
<!--                                                  $root.formData.countryCodeForResidentialContactNum = `+${option.split(`+`)[1]}`-->
<!--                                                  $root.formData.countryCodeForResidentialContactNumTemp = option-->
<!--                                                }-->
<!--                                                else {-->
<!--                                                  $root.formData.countryCodeForResidentialContactNum = ``-->
<!--                                                }-->
<!--                                                if (-->
<!--                                                  $root.formData-->
<!--                                                    .countryCodeForResidentialContactNum-->
<!--                                                ) {-->
<!--                                                  changeResidentialSelection();-->
<!--                                                  calResidentialContactNumber();-->
<!--                                                }-->
<!--                                              }">-->
<!--                                </b-autocomplete>-->

<!--                                <b-select @input="countryCodeLogoFilter" v-model = "residanceCountryCode" placeholder="Country Code" icon-pack="fi" :icon="countryIconStringResidance">-->

<!--                                  <option v-for="country in countryCodeList"-->
<!--                                          :value="country.phone"-->
<!--                                          :key="country.phone">{{country.phone}}</option>-->

<!--                                </b-select>-->
                                <ValidationProvider name="Country Code" :rules="countryCodeValidation()"
                                                    v-slot="{ errors }">
                                <b-autocomplete autocomplete="code_two" @input="residenceCountryCodeLogoFilter" v-model="$root.formData.residenceCountryCode" placeholder="Country Code" icon-pack="fi" :icon="$root.formData.countryIconStringResidance"
                                                :data="residenceFilteredDataArray"
                                                clearable
                                                open-on-focus
                                                @select="option => selected = option">
                                  <template #empty>No results found</template>
                                </b-autocomplete>
                                  <span class="has-text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>

                                <span class="has-text-danger" v-if="
                                  isResidentCountryCodeTouched &&
                                  !$root.formData
                                    .countryCodeForResidentialContactNum
                                ">You have to select a valid country code</span>
                              </p>
                            </b-field>
                          </section>
                          <!-- <b-field>
                        <b-select
                          @input="
                            () => {
                              changeResidentialSelection();
                              calResidentialContactNumber();
                            }
                          "
                          icon-pack="fi"
                          :icon="countryIconString"
                          v-model="
                            $root.formData.countryCodeForResidentialContactNum
                          "
                          rounded
                        >
                          <option
                            v-for="country in $root.formData.countriesList"
                            :key="country.code"
                            :value="country.code"
                          >
                            {{ country.phone }} {{ country.code }}
                          </option>
                        </b-select>
                      </b-field> -->
                        </div>
                      </div>
                      <div class="column">
                        <b-field>
                          <p class="control has-icons-right">
                            <ValidationProvider name="Phone Number" :rules="{ onlyNumbers: true }" v-slot="{ errors }">
                              <b-input autocomplete="code_one" type="tel" v-model="$root.formData.residanceContactNumWithOutCode"
                                       @focus="$inputFocused('contact_no_resident')" @input="
                                  () => {
                                    $inputChanged('contact_no_resident');
                                    contactResidanceContactNo();
                                    calResidanceNumber();
                                  }
                                " @blur="$inputBlured('contact_no_resident')" />
                              <span class="icon is-small is-right mr-2">
                                <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                     height="25" />
                              </span>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                           <span class="has-text-danger" v-if="isResidentNumberStartWithZero">LK numbers can't start with 0 </span>
                               <span class="has-text-danger" v-if="isResidanceNumberLocal">Invalid contact number format</span>
                              <span class="has-text-danger" v-if="isRecidentNumberStartWithZeroLE">Please enter 9 digits valid mobile number without 0</span>

                            </ValidationProvider>
                          </p>
                        </b-field>
                      </div>
                    </div>


                  </div>

                </div>

                <!-- contactNumberOffice -->
                <div class="mt-5">
                  <div class="icon-text" :style="{
                    cursor: 'pointer',
                    color: '#009ec2',
                    'line-height': '20px',
                    'text-decoration': 'underline',
                    'letter-spacing': '0.7px',
                  }">
                    <p v-if="!isHide" @click="visible()">
                      <span class="icon has-text-info">
                        <img src="../assets/images/icons/Blue/Circle Plus.png" alt="Circle_Plus image" />
                      </span>
                      <span v-if="!isHide">{{$root.selectedLanguageData.contactNumberOffice }}</span>
                    </p>
                  </div>
                  <div v-if="isHide">
                    <div v-if="isHide" @click="() => {visibleNot();changeOfficeContactNumCountryCode();$root.formData.officeCountryCode = '+94';$root.formData.officeContactNumWithOutCode = ''  } " class="mb-2">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        <span class="icon has-text-info mr-2">
                          <img src="../assets/images/icons/Blue/Circle Minus.png"
                               alt="Circle_Mini image" /></span>
                        {{ $root.selectedLanguageData.contactNumberOffice }}
                      </label>
                    </div>
                    <div class="columns is-7 is-variable">
                      <div class="column is-one-third">
                        <div>
                          <section>
                            <p class="control has-icons-right">
<!--                              <b-autocomplete v-model="countryOfficeCode" maxlength="10" icon-pack="fi"-->
<!--                                              :icon="iconStringOffice" open-on-focus :data="filteredCountryDataArr"-->
<!--                                              @input="() => { ++countTwo;-->
<!--                                              if (countTwo === 1) {-->
<!--                                                $root.formData.countryCodeForOfficeContactNum = ``;-->
<!--                                                isWorkCountryCodeTouched = true;-->
<!--                                              }}"-->
<!--                                              @select="(option) => {-->
<!--                                                  if (option) {-->
<!--                                                    $root.formData.countryCodeForOfficeContactNum = `+${option.split(`+`)[1]}`-->
<!--                                                    $root.formData.countryCodeForOfficeContactNumTemp = option-->
<!--                                                  }-->
<!--                                                  else {-->
<!--                                                    ($root.formData.countryCodeForOfficeContactNum = ``);-->
<!--                                                  }-->
<!--                                                  if (-->
<!--                                                    $root.formData-->
<!--                                                      .countryCodeForOfficeContactNum-->
<!--                                                  ) {-->
<!--                                                    changeOfficeContactNumCountryCode();-->
<!--                                                    calOfficeContactNumber();-->
<!--                                                  }-->
<!--                                                }">-->
<!--                              </b-autocomplete>-->

<!--                              <b-select @input="countryCodeLogoFilter" v-model = "officeCountryCode" placeholder="Country Code" icon-pack="fi" :icon="countryIconStringOffice">-->

<!--                                <option v-for="country in countryCodeList"-->
<!--                                        :value="country.phone"-->
<!--                                        :key="country.phone">{{country.phone}}</option>-->

<!--                              </b-select>-->
                              <ValidationProvider name="Country Code" :rules="countryCodeValidation()"
                                                  v-slot="{ errors }">
                              <b-autocomplete autocomplete="code_three" @input="countryCodeLogoFilter" v-model="$root.formData.officeCountryCode" placeholder="Country Code" icon-pack="fi" :icon="$root.formData.countryIconStringOffice"
                                              :data="filteredDataArray"
                                              clearable
                                              open-on-focus
                                              @select="option => selected = option">
                                <template #empty>No results found</template>
                              </b-autocomplete>
                                <span class="has-text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>

                              <span class="has-text-danger" v-if="isWorkCountryCodeTouched &&!$root.formData.countryCodeForOfficeContactNum">
                                You have to select a valid country code
                              </span>
                            </p>
                          </section>
                          <!-- <b-field>
                        <b-select
                          @input="
                            () => {
                              changeOfficeContactNumCountryCode();
                              calOfficeContactNumber();
                            }
                          "
                          v-model="
                            $root.formData.countryCodeForOfficeContactNum
                          "
                          icon-pack="fi"
                          :icon="iconStringOffice"
                          rounded
                        >
                          <option
                            v-for="country in $root.formData.countriesList"
                            :key="country.code"
                            :value="country.code"
                          >
                            {{ country.phone }} {{ country.code }}
                          </option>
                        </b-select>
                      </b-field> -->
                        </div>
                      </div>
                      <div class="column">
                        <b-field>
                          <p class="control has-icons-right">
                            <ValidationProvider name="Phone Number" :rules="{ onlyNumbers: true }" v-slot="{ errors }">
                              <b-input autocomplete="code" type="tel" v-model="$root.formData.officeContactNumWithOutCode"
                                       @focus="$inputFocused('contact_no_work')" @blur="$inputBlured('contact_no_work')" @input="
                                  () => {
                                    $inputChanged('contact_no_work');
                                    calOfficeNumber();
                                    contactOfficeContactNo();
                                  } " />
                              <span class="icon is-small is-right mr-2">
                                <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                     height="25" />
                              </span>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                              <span class="has-text-danger" v-if="isOfficeNumberStartWithZero">LK numbers can't start with 0</span>
                               <span class="has-text-danger" v-if="isOfficeNumberLocal">Invalid contact number format</span>
                               <span class="has-text-danger" v-if="isOfficeNumberStartWithZeroLE">Please enter 9 digits valid mobile number without 0</span>
                            </ValidationProvider>
                          </p>
                        </b-field>
                      </div>
                    </div>
                  </div>
                </div>

                <hr>
                <!--are you us person-->
                <div class="field mt-4">
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label` : `` }`">
                      {{ $root.selectedLanguageData.areYouaUSPerson }}
                      <span class="has-text-danger">*</span>
                    </label>

                    <div class="columns">
                      <div class="column is-one-two">
                        <b-field>
                          <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                            <b-radio name="US" style="font-family: OpenSans-Regular" native-value="Yes"
                                     v-model="$root.formData.us_person" @focus="$inputFocused('us_person')"
                                     @blur="$inputBlured('us_person')"
                                     @input="() => {
                                       $inputChanged('us_person');usCountryCodeList();
                                     }">
                              {{ $root.selectedLanguageData.yes }}
                            </b-radio>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </b-field>
                      </div>

                      <div class="column is-one-two">
                        <b-field>
                          <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                            <b-radio name="US" style="font-family: OpenSans-Regular" native-value="No"
                                     @focus="$inputFocused('us_person')" @input="$inputChanged('us_person')"
                                     @blur="$inputBlured('us_person')" v-model="$root.formData.us_person"
                            @click.native="usPersonReseter()">
                              {{ $root.selectedLanguageData.no }}
                            </b-radio>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </b-field>
                      </div>
                    </div>
                  </div>
                  <div :style="{'font-size': '0.9rem','font-family': 'OpenSans-Medium',color: '#636363',}">
                    <span class="has-text-danger">*</span>
                    {{ $root.selectedLanguageData.a_citizen_of_USA }}
                  </div>

                  <!-- this div only for US person -->
                  <div v-if="$root.formData.us_person === `Yes`">
                    <div class="columns">
                      <div class="column is-one-two">
                        <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                          {{ $root.selectedLanguageData.account_number_in_nsb }}
                        </label>
                        <div class="field">
                          <p class="control has-icons-right">
                            <ValidationProvider name="Account Number" :rules="nsbAccountNumbersValidation()"
                                                v-slot="{ errors }">
                              <b-input @focus="$inputFocused('us_person_account_numbers')"
                                       @input="$inputChanged('us_person_account_numbers')"
                                       @blur="$inputBlured('us_person_account_numbers')"
                                       v-model="$root.formData.us_person_account_numbers" />
                              <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </p>
                        </div>
                      </div>
                      <div class="column is-one-two">
                        <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                          {{ $root.selectedLanguageData.place_of_birth }}
                          <span class="has-text-danger">*</span>
                        </label>
                        <div class="field">
                          <p class="control has-icons-right">
                            <ValidationProvider name="Place of birth" :rules="{ required: true, alphaSpaces: true }" v-slot="{ errors }">
                              <b-input type="text" @focus="$inputFocused('us_person_place_of_birth')"
                                       @input="$inputChanged('us_person_place_of_birth')"
                                       @blur="$inputBlured('us_person_place_of_birth')"
                                       v-model="$root.formData.us_person_place_of_birth" />
                              <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="location-img" width="25"
                                   height="25" />
                            </span>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- permanent_address_in_us -->
                    <div class="mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.permanent_address_in_us }}
                        <span class="has-text-danger">*</span></label>
<!--                      <b-field>-->
<!--                        <b-checkbox name="permanent_address_in_us" style="font-family: fira400"-->
<!--                                 native-value="SameAsPermanentAddress" :disabled="-->
<!--                            !$root.formData.permanent_address_line1 ||-->
<!--                            !$root.formData.permanent_address_line2 ||-->
<!--                            !$root.formData.permanent_address_line3 ||-->
<!--                            !$root.formData.permanent_address_country"-->
<!--                                 v-model="$root.formData.address_in_us_same_as_permanent_address"-->
<!--                                 @focus="$inputFocused('address_in_us_same_as_permanent_address')"-->
<!--                                 @blur="$inputBlured('address_in_us_same_as_permanent_address')"-->
<!--                                 @input="() => {$inputChanged('address_in_us_same_as_permanent_address');sameAsPermanentAddressInUs();}">-->
<!--                          {{ $root.selectedLanguageData.sameAsPermanentAddress }}-->
<!--                        </b-checkbox>-->
<!--                      </b-field>-->
                    </div>

                    <div>
                      <!--us person house name-->
                      <div class="mt-4">
                        <p>
                          {{ $root.selectedLanguageData.houseName }}<span class="has-text-danger">*</span>
                        </p>
                        <b-field>
                          <ValidationProvider name="US person permanent address line 1" :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                            <p class="control has-icons-right">
<!--                              :disabled="$root.formData.address_in_us_same_as_permanent_address ===`Same as Permanent Address`"-->
                              <b-input type="text"
                                  @focus="$inputFocused('us_person_permanent_address_line1')"
                                  @input=" $inputChanged('us_person_permanent_address_line1')"
                                  @blur="$inputBlured('us_person_permanent_address_line1')"
                                  v-model="$root.formData.us_person_permanent_address_line1">
                              </b-input>
                              <span class="icon is-small is-right">
                                <img
                                    src="../assets/images/icons/Blue/home.png"
                                    alt="contact-name-img"
                                    width="25"
                                    height="25"
                                />
                              </span>
                            </p>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </b-field>
                      </div>

                      <div class="columns is-7 is-variable mt-2">
                        <!--us person street name-->
                        <div class="column">
                          <p>{{ $root.selectedLanguageData.streetName }}</p>
                          <b-field>
                            <ValidationProvider name="US person permanent address line 2" :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                              <p class="control has-icons-right">

<!--                                :disabled="$root.formData.address_in_us_same_as_permanent_address===`Same as Permanent Address`"-->
                                <b-input type="text"
                                    @focus=" $inputFocused('us_person_permanent_address_line2')"
                                    @input="$inputChanged('us_person_permanent_address_line2')"
                                    @blur="$inputBlured('us_person_permanent_address_line2')"
                                    v-model="$root.formData.us_person_permanent_address_line2"
                                ></b-input>
                                <span class="icon is-small is-right">
                                  <img
                                      src="../assets/images/icons/Blue/Location.png"
                                      alt="contact-name-img"
                                      width="25"
                                      height="25"
                                  />
                                </span>
                              </p>
                              <span class="has-text-danger">{{errors[0] }}</span>
                            </ValidationProvider>
                          </b-field>
                        </div>

                        <!--us person city-->
                        <div class="column">
                          <p>{{ $root.selectedLanguageData.city }}</p>
                          <b-field>
                            <ValidationProvider name="US person permanent address line 3" :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                              <p class="control has-icons-right">

<!--                                :disabled="$root.formData.address_in_us_same_as_permanent_address ===`Same as Permanent Address`"-->
                                <b-input type="text"
                                    @focus="$inputFocused('us_person_permanent_address_line3')"
                                    @input="$inputChanged('us_person_permanent_address_line3')"
                                    @blur="$inputBlured('us_person_permanent_address_line3')"
                                    v-model="$root.formData.us_person_permanent_address_line3">
                                </b-input>
                                <span class="icon is-small is-right">
                                  <img
                                      src="../assets/images/icons/Blue/Location.png"
                                      alt="contact-name-img"
                                      width="25"
                                      height="25"
                                  />
                                </span>
                              </p>
                              <span class="has-text-danger">{{errors[0] }}</span>
                            </ValidationProvider>
                          </b-field>
                        </div>
                      </div>

                      <div class="columns is-7 is-variable">
                        <!--us person postal code-->
                        <div class="column">
                          <p>{{ $root.selectedLanguageData.postalCode }}</p>
                          <b-field>
                            <p class="control has-icons-right">

<!--                              :disabled="$root.formData.address_in_us_same_as_permanent_address ===`Same as Permanent Address`"-->
                              <b-input type="text"
                                  @focus="$inputFocused('us_person_permanent_address_postal_code')"
                                  @input="$inputChanged('us_person_permanent_address_postal_code')"
                                  @blur="$inputBlured('us_person_permanent_address_postal_code')"
                                  v-model="$root.formData.us_person_permanent_address_postal_code">
                              </b-input>
                              <span class="icon is-small is-right">
                                <img
                                    src="../assets/images/icons/Blue/Edit.png"
                                    alt="contact-name-img"
                                    width="25"
                                    height="25"
                                />
                              </span>
                            </p>
                          </b-field>
                        </div>
                        <!--us person country-->
                        <div class="column">
                          <p>{{ $root.selectedLanguageData.country }}</p>
                          <div>
                            <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                              <div style="width: 100%">

<!--                                :disabled="$root.formData.address_in_us_same_as_permanent_address ===`Same as Permanent Address`"-->
                                <b-select
                                    @focus="$inputFocused('us_person_permanent_address_country')"
                                    @input="$inputChanged('us_person_permanent_address_country')"
                                    @blur="$inputBlured('us_person_permanent_address_country')"
                                    v-model="$root.formData.us_person_permanent_address_country"
                                     expanded>
                                  <option
                                      v-for="country in $root.selectedLanguageData
                                      .countries"
                                      :key="country.value"
                                      :value="country.value"
                                  >
                                    {{ country.countryName }}
                                  </option>
                                </b-select>
<!--                                <b-field>-->
<!--                                  <p class="control has-icons-right">-->
<!--                                <b-input type="text"-->
<!--                                         @focus="$inputFocused('us_person_permanent_address_country')"-->
<!--                                         @input="$inputChanged('us_person_permanent_address_country')"-->
<!--                                         @blur="$inputBlured('us_person_permanent_address_country')"-->
<!--                                         v-model="$root.formData.us_person_permanent_address_country"-->
<!--                                disabled>-->
<!--                                </b-input>-->
<!--                                    <span class="icon is-small is-right">-->
<!--                            <img src="../assets/images/icons/Blue/country.png" alt="country-img" width="25"-->
<!--                                 height="25" />-->
<!--                          </span>-->
<!--                                  </p>-->
<!--                                </b-field>-->
                              </div>
                              <span class="has-text-danger">{{errors[0] }}</span>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- mailing Address in US-->
                    <div class="mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                        {{ $root.selectedLanguageData.mailingAddress }} <span class="has-text-danger">*</span></label>
                      <b-field>
                        <b-checkbox name="permanent_address_in_us" style="font-family: OpenSans-Regular "
                                    :native-value="`same`" :disabled="
                            !$root.formData.us_person_permanent_address_line1 ||
                            !$root.formData.us_person_permanent_address_line2 ||
                            !$root.formData.us_person_permanent_address_line3 ||
                            !$root.formData.us_person_permanent_address_postal_code ||
                            !$root.formData.us_person_permanent_address_country"

                                    v-model="$root.formData.mailing_address_in_us_same_as_permanent_address_in_us"
                                    @focus="$inputFocused('mailing_address_in_us_same_as_permanent_address_in_us')"
                                    @blur="$inputBlured('mailing_address_in_us_same_as_permanent_address_in_us')"
                                    @input="() => {$inputChanged('mailing_address_in_us_same_as_permanent_address_in_us');mailingAddressSameAsPermanentAddessInUS();}">
                         <p style="font-size:0.9rem;">{{ $root.selectedLanguageData.sameAsPermanentAddress }}</p>
                        </b-checkbox>
                      </b-field>

                      <!--mailing address house name-->
                      <div class="mt-1">
                        <p>
                          {{ $root.selectedLanguageData.houseName }}
<!--                          <span class="has-text-danger">*</span>-->
                        </p>
                        <b-field>
                          <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                            <p class="control has-icons-right">
                              <b-input type="text" @focus="$inputFocused('us_person_mailing_address_line1')"
                                       @input="$inputChanged('us_person_mailing_address_line1')"
                                       @blur="$inputBlured('us_person_mailing_address_line1')"
                                       v-model="$root.formData.us_person_mailing_address_line1"
                                       :disabled="$root.formData.mailing_address_in_us_same_as_permanent_address_in_us">
                              </b-input>
                              <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                            </p>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </b-field>
                      </div>

                      <div class="columns is-7 is-variable mt-2">
                        <!--mailing address street name-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.streetName }}
<!--                            <span class="has-text-danger">*</span>-->
                          </p>
                          <b-field>
                            <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                              <p class="control has-icons-right">
                                <b-input type="text" @focus="$inputFocused('us_person_mailing_address_line2')"
                                         @input="$inputChanged('us_person_mailing_address_line2')"
                                         @blur="$inputBlured('us_person_mailing_address_line2')"
                                         v-model="$root.formData.us_person_mailing_address_line2"
                                         :disabled="$root.formData.mailing_address_in_us_same_as_permanent_address_in_us">
                                </b-input>
                                <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                              </p>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </b-field>
                        </div>
                        <!--mailing address city-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.city }}
<!--                            <span class="has-text-danger">*</span>-->
                          </p>
                          <b-field>
                            <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                              <p class="control has-icons-right">
                                <b-input type="text" @focus="$inputFocused('us_person_mailing_address_line3')"
                                         @input="$inputChanged('us_person_mailing_address_line3')"
                                         @blur="$inputBlured('us_person_mailing_address_line3')"
                                         v-model="$root.formData.us_person_mailing_address_line3"
                                         :disabled="$root.formData.mailing_address_in_us_same_as_permanent_address_in_us">
                                </b-input>
                                <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                              </p>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </b-field>
                        </div>
                      </div>
                      <div class="columns is-7 is-variable">
                        <!--mailing postal code-->
                        <div class="column">
                          <p>{{ $root.selectedLanguageData.postalCode }}</p>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-input type="text" @focus="$inputFocused('us_person_mailing_address_postal_code')"
                                       @input="$inputChanged('us_person_mailing_address_postal_code')"
                                       @blur="$inputBlured('us_person_mailing_address_postal_code')"
                                       v-model="$root.formData.us_person_mailing_address_postal_code"
                                       :disabled="$root.formData.mailing_address_in_us_same_as_permanent_address_in_us">
                              </b-input>
                              <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                            </p>
                          </b-field>
                        </div>
                        <!--mailing address country-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.country }}
<!--                            <span class="has-text-danger">*</span>-->
                          </p>
                          <div>
                            <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                              <div style="width: 100%">
                                <b-select @focus="$inputFocused('us_person_mailing_address_country')"
                                          @input="$inputChanged('us_person_mailing_address_country')"
                                          @blur="$inputBlured('us_person_mailing_address_country')"
                                          v-model="$root.formData.us_person_mailing_address_country"
                                          :disabled="$root.formData.mailing_address_in_us_same_as_permanent_address_in_us" expanded>
                                  <option v-for="country in $root.selectedLanguageData.countries" :key="country.value" :value="country.value">
                                    {{ country.countryName }}
                                  </option>
                                </b-select>
<!--                                <b-field>-->
<!--                                  <p class="control has-icons-right">-->
<!--                                <b-input type="text"-->
<!--                                         @focus="$inputFocused('us_person_mailing_address_country')"-->
<!--                                         @input="$inputChanged('us_person_mailing_address_country')"-->
<!--                                         @blur="$inputBlured('us_person_mailing_address_country')"-->
<!--                                         v-model="$root.formData.us_person_mailing_address_country"-->
<!--                                         disabled>-->
<!--                                </b-input>-->
<!--                                    <span class="icon is-small is-right">-->
<!--                            <img src="../assets/images/icons/Blue/country.png" alt="country-img" width="25"-->
<!--                                 height="25" />-->
<!--                          </span>-->
<!--                                  </p>-->
<!--                                </b-field>-->
                              </div>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--us_person_passport_no -->
                    <div class="mt-4">
                      <div>
                        <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                          {{ $root.selectedLanguageData.passportNo }}<span class="has-text-danger">*</span>
                        </label>
                        <b-field>
                          <b-checkbox name="account holder passport number same as above" style="font-family: OpenSans-Regular"
                                       :disabled="
                            !$root.formData.account_holder_passport_number"

                                      v-model="$root.formData.same_passport_number"
                                      @focus="$inputFocused('same_passport_number')"
                                      @blur="$inputBlured('same_passport_number')"
                                      @input="() => {$inputChanged('same_passport_number')}"
                                      @change.native="sameAsAbovePassport()">
                           <p style="font-size:0.9rem;">{{ $root.selectedLanguageData.same_as_the_previously_entered }}</p>
                          </b-checkbox>
                        </b-field>
                        <b-field>
                          <ValidationProvider :rules="passportValidateObject()" v-slot="{ errors }">
                            <p class="control has-icons-right">
                              
                              <b-input 
                                       
                                       @focus="$inputFocused('us_person_passport_no')"
                                       @input="$inputChanged('us_person_passport_no')"
                                       @blur="$inputBlured('us_person_passport_no')"
                                       v-model="$root.formData.us_person_passport_no" :disabled="$root.formData.same_passport_number=== true"></b-input>
                              <span class="icon is-small is-right">
                                <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                     height="25" />
                              </span>
                            </p>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </b-field>
                      </div>
                    </div>

                    <!--us_person_telephone number -->
                    <div class="mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                        {{ $root.selectedLanguageData.us_telephone_number }}
                        <span class="has-text-danger">*</span></label>
                      <div class="columns is-7 is-variable">
                        <div class="column is-one-third">
                          <div>
                            <b-field>
                              <ValidationProvider name="your country code" :rules="{ required: true }" v-slot="{ errors }">
                                <b-select @input="changeUsContactNumCountryCode()"
                                          v-model="$root.formData.usTellCountryCode" icon-pack="fi" :icon="iconStringUs" disabled>
                                  <option v-for="country in $root.formData
                                    .countriesList" :key="country.code" :value="country.code">
                                    {{ country.phone }}
                                  </option>
                                </b-select>
                                <span class="has-text-danger">{{errors[0] }}</span>
                              </ValidationProvider>
                            </b-field>
                          </div>
                        </div>
                        <div class="column">
                          <b-field>
                            <p class="control has-icons-right">
                              <ValidationProvider name="Phone Number" :rules="{required: true,onlyNumbers: true,}" v-slot="{ errors }">
                                <b-input type="tel" v-model="$root.formData.us_tel_number"
                                         @focus="$inputFocused('us_tel_number')"
                                         @blur="$inputBlured('us_tel_number')"
                                         @input="() => {$inputChanged('us_tel_number');calUsContactNumber();}" />
                                <span class="icon is-small is-right mr-2">
                                  <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                       height="25" />
                                </span>
                                <span class="has-text-danger">{{errors[0] }}</span>
                              </ValidationProvider>
                            </p>
                          </b-field>
                        </div>
                      </div>
                
                    </div>

                    <div class="mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{$root.selectedLanguageData.tax_identification_number_or_social_security_number }}
                        <span class="has-text-danger">*</span></label>
                      <div class="field">
                        <p class="control has-icons-right">
                          <ValidationProvider name="Tax Identification Number in US/ Social Security Number" :rules="ssnValidation()" v-slot="{ errors }">
                            <b-input type="text" @focus="$inputFocused('us_person_tax_identification_no')"
                                     @input="$inputChanged('us_person_tax_identification_no')"
                                     @blur="$inputBlured('us_person_tax_identification_no')"
                                     v-model="$root.formData.us_person_tax_identification_no" />
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>


<!--                <div class="columns is-7 is-variable">-->

<!--                  <div class="column" v-if="-->
<!--                    $root.formData.account_type ===-->
<!--                    `Personal Foreign Currency Account`-->
<!--                  ">-->
<!--                    <div>-->
<!--                      <label :class="`${$root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                            ? `si-label`-->
<!--                            : ``-->
<!--                        }`">{{ $root.selectedLanguageData.passportNo-->
<!--  }}<span class="has-text-danger">*</span></label>-->




<!--                      <b-field>-->
<!--                        <p class="control has-icons-right">-->
<!--                          <ValidationProvider :rules="passportValidateObject()" v-slot="{ errors }">-->
<!--                            <b-input type="text" :disabled="$root.formData.idType === `PNO`"-->
<!--                              @focus="$inputFocused('customer_passport_no')"-->
<!--                              @input="$inputChanged('customer_passport_no')" @blur="$inputBlured('customer_passport_no')"-->
<!--                              v-model="$root.formData.customer_passport_no" />-->
<!--                            <span class="icon is-small is-right">-->
<!--                              <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"-->
<!--                                height="25" />-->
<!--                            </span>-->
<!--                            <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                          </ValidationProvider>-->
<!--                        </p>-->
<!--                      </b-field>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->


                <!-- Nationality & Citizenship -->
<!--                <div class="mb-5 mt-4" v-if="$root.kycFieldVisibility.citizenship">-->
<!--                  <label :class="`${$root.selectedLanguage === `ta`-->
<!--                      ? `ta-label`-->
<!--                      : $root.selectedLanguage === `si`-->
<!--                        ? `si-label`-->
<!--                        : ``-->
<!--                    }`">-->
<!--                    {{ $root.selectedLanguageData.nationalityCitizenship-->
<!--                    }}<span class="has-text-danger">*</span></label>-->
<!--                  <div style="width: 100%">-->
<!--                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                      <b-select style="width: 100%" expanded v-model="$root.formData.citizenship"-->
<!--                        @focus="$inputFocused('citizenship')" @input="-->
<!--                          () => {-->
<!--                            $inputChanged('citizenship');-->
<!--                            dualCitizenCounties();-->
<!--                          }-->
<!--                        " @blur="$inputBlured('citizenship')">-->
<!--                        <option value="Sri Lankan">-->
<!--                          {{ $root.selectedLanguageData.srilanka }}-->
<!--                        </option>-->
<!--                        <option value="Sri Lankan with Dual Citizenship">-->
<!--                          {{-->
<!--                            $root.selectedLanguageData-->
<!--                              .sriLankanWithDualCitizenship-->
<!--                          }}-->
<!--                        </option>-->
<!--                        <option value="Foreign National">-->
<!--                          {{ $root.selectedLanguageData.foreignNational }}-->
<!--                        </option>-->
<!--                        <option value="Foreign National with Dual Citizenship">-->
<!--                          {{-->
<!--                            $root.selectedLanguageData-->
<!--                              .foreignNationalWithDualCitizenship-->
<!--                          }}-->
<!--                        </option>-->
<!--                      </b-select>-->
<!--                      <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                    </ValidationProvider>-->
<!--                  </div>-->
<!--                </div>-->
                <!-- This div for SriLankan National With Dual Citizenship -->
<!--                <div v-if="-->
<!--                  $root.formData.citizenship ===-->
<!--                  `Sri Lankan with Dual Citizenship` &&-->
<!--                  $root.kycFieldVisibility.dual_citizen_countries-->
<!--                ">-->
<!--                  <div>-->
<!--                    <label :class="`${$root.selectedLanguage === `ta`-->
<!--                        ? `ta-label`-->
<!--                        : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`">-->
<!--                      {{-->
<!--                        $root.selectedLanguageData-->
<!--                          .namesOfTheCountryYouhaveDualCitizenships-->
<!--                      }}<span class="has-text-danger">*</span></label>-->

<!--                    <div>-->
<!--                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                        <div style="width: 100%">-->
<!--                          <b-select @focus="$inputFocused('dual_citizen_countries')"-->
<!--                            @input="$inputChanged('dual_citizen_countries')"-->
<!--                            @blur="$inputBlured('dual_citizen_countries')" v-model="$root.formData.dual_citizen_countries"-->
<!--                            expanded>-->
<!--                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">-->
<!--                              {{ country.countryName }}-->
<!--                            </option>-->
<!--                          </b-select>-->
<!--                        </div>-->
<!--                        <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <!-- This div for Foreign-National With Dual Citizenship -->
<!--                <div v-if="-->
<!--                  $root.formData.citizenship ===-->
<!--                  `Foreign National with Dual Citizenship` &&-->
<!--                  $root.kycFieldVisibility.dual_citizen_countries-->
<!--                ">-->
<!--                  <div>-->
<!--                    <label :class="`${$root.selectedLanguage === `ta`-->
<!--                        ? `ta-label`-->
<!--                        : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`">-->
<!--                      {{-->
<!--                        $root.selectedLanguageData-->
<!--                          .namesOfTheseCountriesYouhaveDualCitizenships-->
<!--                      }}<span class="has-text-danger">*</span></label>-->
<!--                    <p :style="{-->
<!--                      'font-size': '0.95rem',-->
<!--                      'font-family': 'fira400',-->
<!--                      color: '#636363',-->
<!--                    }">-->
<!--                      {{-->
<!--                        $root.selectedLanguageData-->
<!--                          .note_you_can_select_only_two_countries-->
<!--                      }}-->
<!--                    </p>-->
<!--                    <div>-->
<!--                      <ValidationProvider :rules="foreignNationalWithDualCitizenshipValidation()" v-slot="{ errors }"-->
<!--                        name="countries">-->
<!--                        <b-dropdown @focus="$inputFocused('dual_citizen_countries')"-->
<!--                          @input="$inputChanged('dual_citizen_countries')" @blur="$inputBlured('dual_citizen_countries')"-->
<!--                          v-model="$root.formData.dual_citizen_countries" multiple expanded :scrollable="true"-->
<!--                          :max-height="300" aria-role="list">-->
<!--                          <template #trigger>-->
<!--                            <b-select style="width: 100%" expanded-->
<!--                              :placeholder="$root.selectedLanguageData.selectCountries"></b-select>-->
<!--                          </template>-->

<!--                          <b-dropdown-item v-for="country in $root.selectedLanguageData-->
<!--                            .countries" :key="country.value" :value="country.value" aria-role="listitem" @click="-->
<!--    foreignNationalWithDualCitizenshipTextArea =-->
<!--    $root.formData.dual_citizen_countries.toString()-->
<!--  ">-->
<!--                            <span>{{ country.countryName }}</span>-->
<!--                          </b-dropdown-item>-->
<!--                        </b-dropdown>-->
<!--                        <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </div>-->

<!--                    <div v-if="$root.formData.dual_citizen_countries.length > 0">-->
<!--                      <div class="area mt-4">-->
<!--                        <span v-for="item in $root.formData.dual_citizen_countries" :key="item" class="items">-->
<!--                          {{ item }}-->
<!--                          <span @click="removeItem(item)" style="cursor: pointer" class="ml-2">x</span>-->
<!--                        </span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <!-- this div for foreign_national -->
<!--                <div v-if="-->
<!--                  $root.formData.citizenship === `Foreign National` &&-->
<!--                  $root.kycFieldVisibility.foreign_national_country-->
<!--                ">-->
<!--                  <div>-->
<!--                    <label :class="`${$root.selectedLanguage === `ta`-->
<!--                        ? `ta-label`-->
<!--                        : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`">-->
<!--                      {{ $root.selectedLanguageData.nationality-->
<!--                      }}<span class="has-text-danger">*</span></label>-->

<!--                    <div>-->
<!--                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                        <div style="width: 100%">-->
<!--                          <b-select @focus="$inputFocused('foreign_national_country')"-->
<!--                            @input="$inputChanged('foreign_national_country')"-->
<!--                            @blur="$inputBlured('foreign_national_country')"-->
<!--                            v-model="$root.formData.foreign_national_country" expanded>-->
<!--                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">-->
<!--                              {{ country.countryName }}-->
<!--                            </option>-->
<!--                          </b-select>-->
<!--                        </div>-->
<!--                        <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <!-- Residency -->
<!--                <div class="field mt-4" v-if="$root.kycFieldVisibility.residentship">-->
<!--                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">-->
<!--                    {{ $root.selectedLanguageData.residency }}-->
<!--                    <span class="has-text-danger">*-->
<!--                    </span>-->
<!--                  </label>-->

<!--                  <div class="columns">-->
<!--                    <div class="column is-one-two">-->
<!--                      <b-field>-->
<!--                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                          <b-radio name="residence" style="font-family: fira400" native-value="Resident in Sri Lanka"-->
<!--                            @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"-->
<!--                            @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"-->
<!--                            @click.native="countrySelect(`Sri Lanka`)">-->
<!--                            {{-->
<!--                              $root.selectedLanguageData.residentInSriLanka-->
<!--                            }} </b-radio><span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                        </ValidationProvider>-->
<!--                      </b-field>-->
<!--                    </div>-->
<!--                    <div class="column is-one-two">-->
<!--                      <b-field>-->
<!--                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                          <b-radio name="residence" style="font-family: fira400" native-value="Non Resident"-->
<!--                            @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"-->
<!--                            @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"-->
<!--                            @click.native="countrySelect(``)">-->
<!--                            {{ $root.selectedLanguageData.nonResident }} </b-radio><span class="has-text-danger">{{-->
<!--                              errors[0] }}</span>-->
<!--                        </ValidationProvider>-->
<!--                      </b-field>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <!-- Residency -->
                <!-- this div for non-residence -->
<!--                <div>-->
<!--                  <div v-if="$root.kycFieldVisibility.resident_countries">-->
<!--                    <label :class="`${$root.selectedLanguage === `ta`-->
<!--                        ? `ta-label`-->
<!--                        : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`">{{-->
<!--    $root.selectedLanguageData-->
<!--      .please_select_the_country_of_residence-->
<!--  }}<span class="has-text-danger">*</span></label>-->

<!--                    <div>-->
<!--                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                        <div style="width: 100%">-->
<!--                          <b-select @focus="$inputFocused('resident_countries')"-->
<!--                            @input="$inputChanged('resident_countries')" @blur="$inputBlured('resident_countries')"-->
<!--                            v-model="$root.formData.resident_countries" expanded>-->
<!--                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">-->
<!--                              {{ country.countryName }}-->
<!--                            </option>-->
<!--                          </b-select>-->
<!--                        </div>-->
<!--                        <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->


                <!--foreign address -->
<!--                <div-->
<!--              class="mt-4"-->
<!--              v-if="-->
<!--                $root.formData.account_type === `PFC` ||-->
<!--                $root.formData.selectnationalityCitizenship ===-->
<!--                  `Sri Lankan with Dual Citizenship` ||-->
<!--                $root.formData.selectnationalityCitizenship ===-->
<!--                  `Foreign National` ||-->
<!--                $root.formData.selectnationalityCitizenship ===-->
<!--                  `Foreign National with Dual Citizenship` ||-->
<!--                $root.formData.nationalityCitizenship === `Non Resident`-->
<!--              "-->
<!--            >-->
<!--              <label>{{ $root.selectedLanguageData.foreignAddress }}</label>-->
<!--              <div class="mt-1">-->
<!--                <p>-->
<!--                  {{ $root.selectedLanguageData.houseName }}-->
<!--                </p>-->
<!--                <b-field>-->
<!--                  <p class="control has-icons-right">-->
<!--                    <b-input-->
<!--                      type="text"-->
<!--                      v-model="$root.formData.foreign_address_line1"-->
<!--                      rounded-->
<!--                    ></b-input>-->
<!--                    <span class="icon is-small is-right">-->
<!--                      <img-->
<!--                        src="../assets/images/icons/Yellow/homeName.png"-->
<!--                        alt="contact-name-img"-->
<!--                        width="25"-->
<!--                        height="25"-->
<!--                      />-->
<!--                    </span>-->
<!--                  </p>-->
<!--                </b-field>-->
<!--              </div>-->
<!--              <div class="columns is-7 is-variable mt-2">-->
<!--                <div class="column">-->
<!--                  <p>{{ $root.selectedLanguageData.streetName }}</p>-->
<!--                  <b-field>-->
<!--                    <p class="control has-icons-right">-->
<!--                      <b-input-->
<!--                        type="text"-->
<!--                        v-model="$root.formData.foreign_address_line2"-->
<!--                        rounded-->
<!--                      ></b-input>-->
<!--                      <span class="icon is-small is-right">-->
<!--                        <img-->
<!--                          src="../assets/images/icons/Yellow/Location.png"-->
<!--                          alt="contact-name-img"-->
<!--                          width="25"-->
<!--                          height="25"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </p>-->
<!--                  </b-field>-->
<!--                </div>-->
<!--                <div class="column">-->
<!--                  <p>{{ $root.selectedLanguageData.city }}</p>-->
<!--                  <b-field>-->
<!--                    <p class="control has-icons-right">-->
<!--                      <b-input-->
<!--                        type="text"-->
<!--                        v-model="$root.formData.foreign_address_line3"-->
<!--                        rounded-->
<!--                      ></b-input>-->
<!--                      <span class="icon is-small is-right">-->
<!--                        <img-->
<!--                          src="../assets/images/icons/Yellow/Location.png"-->
<!--                          alt="contact-name-img"-->
<!--                          width="25"-->
<!--                          height="25"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </p>-->
<!--                  </b-field>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="columns is-7 is-variable">-->
<!--                <div class="column">-->
<!--                  <p>{{ $root.selectedLanguageData.postalCode }}</p>-->
<!--                  <b-field>-->
<!--                    <p class="control has-icons-right">-->
<!--                      <b-input-->
<!--                        type="text"-->
<!--                        v-model="$root.formData.foreign_address_postal_code"-->
<!--                        rounded-->
<!--                      ></b-input>-->
<!--                      <span class="icon is-small is-right">-->
<!--                        <img-->
<!--                          src="../assets/images/icons/Yellow/Edit.png"-->
<!--                          alt="contact-name-img"-->
<!--                          width="25"-->
<!--                          height="25"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </p>-->
<!--                  </b-field>-->
<!--                </div>-->
<!--                <div class="column">-->
<!--                  <p>{{ $root.selectedLanguageData.country }}</p>-->
<!--                  <div>-->
<!--                    <div style="width: 100%">-->
<!--                      <b-select-->
<!--                        v-model="$root.formData.foreign_address_country"-->
<!--                        expanded-->
<!--                        rounded-->
<!--                      >-->
<!--                        <option-->
<!--                          v-for="country in $root.selectedLanguageData-->
<!--                            .countries"-->
<!--                          :key="country.value"-->
<!--                          :value="country.value"-->
<!--                        >-->
<!--                          {{ country.countryName }}-->
<!--                        </option>-->
<!--                      </b-select>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->


                <!-- permanent address_1 -->
<!--              <div>-->
<!--              <div class="field mb-5">-->
<!--                <label-->
<!--                  >{{ $root.selectedLanguageData.permanentAddressLine_1 }}-->
<!--                  <span class="has-text-danger">*</span></label-->
<!--                >-->
<!--                <b-field>-->
<!--                  <ValidationProvider-->
<!--                    :rules="{ required: true }"-->
<!--                    v-slot="{ errors }"-->
<!--                  >-->
<!--                    <p class="control has-icons-right">-->
<!--                      <b-input-->
<!--                        type="text"-->
<!--                        v-model="$root.formData.permanentAddressLineOne"-->
<!--                        @input="permanentAddressChange()"-->
<!--                        rounded-->
<!--                      ></b-input>-->
<!--                      <span class="icon is-small is-right">-->
<!--                        <img-->
<!--                          src="../assets/images/icons/Yellow/Location.png"-->
<!--                          alt="contact-name-img"-->
<!--                          width="25"-->
<!--                          height="25"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </p>-->
<!--                    <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                  </ValidationProvider>-->
<!--                </b-field>-->
<!--              </div>-->
<!--                &lt;!&ndash; pemanent address_2 &ndash;&gt;-->
<!--                <div class="field mb-5">-->
<!--                <label-->
<!--                  >{{ $root.selectedLanguageData.permanentAddressLine_2 }}-->
<!--                  <span class="has-text-danger">*</span></label-->
<!--                >-->
<!--                <b-field>-->
<!--                  <ValidationProvider-->
<!--                    :rules="{ required: true }"-->
<!--                    v-slot="{ errors }"-->
<!--                  >-->
<!--                    <p class="control has-icons-right">-->
<!--                      <b-input-->
<!--                        type="text"-->
<!--                        v-model="$root.formData.permanentAddressLineTwo"-->
<!--                        @input="permanentAddressChange()"-->
<!--                        rounded-->
<!--                      ></b-input>-->
<!--                      <span class="icon is-small is-right">-->
<!--                        <img-->
<!--                          src="../assets/images/icons/Yellow/Location.png"-->
<!--                          alt="contact-name-img"-->
<!--                          width="25"-->
<!--                          height="25"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </p>-->
<!--                    <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                  </ValidationProvider>-->
<!--                </b-field>-->
<!--              </div>-->
<!--                &lt;!&ndash; pemanent address_3 &ndash;&gt;-->
<!--                 <div class="field mb-5">-->
<!--                <label-->
<!--                  >{{ $root.selectedLanguageData.permanentAddressLine_3 }}-->
<!--                  <span class="has-text-danger">*</span></label-->
<!--                >-->
<!--                <b-field>-->
<!--                  <ValidationProvider-->
<!--                    :rules="{ required: true }"-->
<!--                    v-slot="{ errors }"-->
<!--                  >-->
<!--                    <p class="control has-icons-right">-->
<!--                      <b-input-->
<!--                        type="text"-->
<!--                        v-model="$root.formData.permanentAddressLineThree"-->
<!--                        @input="permanentAddressChange()"-->
<!--                        rounded-->
<!--                      ></b-input>-->
<!--                      <span class="icon is-small is-right">-->
<!--                        <img-->
<!--                          src="../assets/images/icons/Yellow/Location.png"-->
<!--                          alt="contact-name-img"-->
<!--                          width="25"-->
<!--                          height="25"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </p>-->
<!--                    <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                  </ValidationProvider>-->
<!--                </b-field>-->
<!--              </div>-->
<!--                </div>-->
                <!-- ResidentialAddress -->
<!--                 <div>-->
<!--              <div-->
<!--                class="is-flex is-flex-direction-row is-justify-content-space-between"-->
<!--              >-->
<!--                <label-->
<!--                  >{{ $root.selectedLanguageData.residentialAddress }}-->
<!--                  <span class="has-text-danger">*</span></label-->
<!--                >-->

<!--                <b-field>-->
<!--                  <b-checkbox-->
<!--                    type="is-primary"-->
<!--                    v-model="$root.formData.sameAsPermanentAddress"-->
<!--                    @change.native="residentialAddress()"-->
<!--                    >{{-->
<!--                      $root.selectedLanguageData.sameAsPermanentAddress-->
<!--                    }}</b-checkbox-->
<!--                  >-->
<!--                </b-field>-->
<!--              </div>-->
<!--              <div class="mb-5">-->
<!--                <b-field>-->
<!--                  <ValidationProvider-->
<!--                    :rules="{ required: true }"-->
<!--                    v-slot="{ errors }"-->
<!--                  >-->
<!--                    <p class="control has-icons-right">-->
<!--                      <b-input-->
<!--                        type="textarea"-->
<!--                        v-model="$root.formData.residentialAddress"-->
<!--                        :disabled="$root.formData.sameAsPermanentAddress"-->
<!--                        rounded-->
<!--                      ></b-input>-->
<!--                      <span class="icon is-small is-right">-->
<!--                        <img-->
<!--                          src="../assets/images/icons/Yellow/Location.png"-->
<!--                          alt="contact-name-img"-->
<!--                          width="25"-->
<!--                          height="25"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </p>-->
<!--                    <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                  </ValidationProvider>-->
<!--                </b-field>-->
<!--              </div>-->
<!--            </div>-->
                <!-- foreign Address -->
<!--                 <div class="mb-5">-->
<!--              <div-->
<!--                class="icon-text field"-->
<!--                style="-->
<!--                  cursor: pointer;-->
<!--                  color: #eebe2c;-->
<!--                  line-height: 20px;-->
<!--                  text-decoration: underline;-->
<!--                  letter-spacing: 0.7px;-->
<!--                "-->
<!--              >-->
<!--                <p-->
<!--                  v-if="!textArea && !$root.formData.foreignAddress"-->
<!--                  @click="showTextArea()"-->
<!--                >-->
<!--                  <span class="icon has-text-info">-->
<!--                    <img-->
<!--                      src="../assets/images/icons/Yellow/Circle Plus.png"-->
<!--                      alt="Circle_Plus image"-->
<!--                    />-->
<!--                  </span>-->
<!--                  {{ $root.selectedLanguageData.foreignAddress }}-->
<!--                </p>-->
<!--              </div>-->
<!--              <div v-if="textArea || $root.formData.foreignAddress">-->
<!--                <label>{{ $root.selectedLanguageData.foreignAddress }}</label>-->
<!--                <b-field>-->
<!--                  <p class="control has-icons-right">-->
<!--                    <b-input-->
<!--                      type="textarea"-->
<!--                      placeholder="ForeignAddress"-->
<!--                      v-model="$root.formData.foreignAddress"-->
<!--                      rounded-->
<!--                    ></b-input>-->
<!--                    <span class="icon is-small is-right">-->
<!--                      <img-->
<!--                        src="../assets/images/icons/Yellow/Location.png"-->
<!--                        alt="contact-name-img"-->
<!--                        width="30"-->
<!--                        height="30"-->
<!--                      />-->
<!--                    </span>-->
<!--                  </p>-->
<!--                </b-field>-->
<!--              </div>-->
<!--            </div>-->
                <!-- State Of PermanentAddress -->
<!--                 <div class="mb-5">-->
<!--              <label>-->
<!--                {{ $root.selectedLanguageData.stateOfPermanentAddress-->
<!--                }}<span class="has-text-danger">*</span></label-->
<!--              >-->

<!--              <div style="width: 100%">-->
<!--                <ValidationProvider-->
<!--                  :rules="{ required: true }"-->
<!--                  v-slot="{ errors }"-->
<!--                >-->
<!--                  <b-select-->
<!--                    expanded-->
<!--                    rounded-->
<!--                    v-model="$root.formData.selectStateOfPermanentAddress"-->
<!--                  >-->
<!--                    <option>{{ $root.selectedLanguageData.own }}</option>-->
<!--                    <option>{{ $root.selectedLanguageData.rent }}</option>-->
<!--                    <option>{{ $root.selectedLanguageData.parents }}</option>-->
<!--                    <option>{{ $root.selectedLanguageData.official }}</option>-->
<!--                    <option>-->
<!--                      {{ $root.selectedLanguageData.friends_relative }}-->
<!--                    </option>-->
<!--                    <option>-->
<!--                      {{ $root.selectedLanguageData.board_lodging }}-->
<!--                    </option>-->
<!--                  </b-select>-->
<!--                  <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                </ValidationProvider>-->
<!--              </div>-->
<!--            </div>-->

                <!-- this div only for who haven't Nationality & Citizenship  in srilanka-->

<!--                check person pay tax and get tax file number-->
                <div class="field mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{ $root.selectedLanguageData.are_you_a_tax_payer
                    }}<span class="has-text-danger">*</span></label>

                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <div class="columns">
                      <div class="column is-one-two">
                        <b-field>
                          <b-radio name="AreYouPayTax" style="font-family: OpenSans-Regular"
                                   native-value="Yes" @focus="$inputFocused('tax_payer')"
                                   @input="$inputChanged('tax_payer')" @blur="$inputBlured('tax_payer')"
                                   v-model="$root.formData.tax_payer">
                            {{ $root.selectedLanguageData.yes }}
                          </b-radio></b-field>
                      </div>

                      <div class="column is-one-two">
                        <b-field>
                          <b-radio name="AreYouPayTax" style="font-family: OpenSans-Regular"
                                   native-value="No" @focus="$inputFocused('tax_payer')"
                                   @input="$inputChanged('tax_payer')" @blur="$inputBlured('tax_payer')"
                                   v-model="$root.formData.tax_payer"
                                    @click.native="$root.formData.tax_file_number = ''">
                            {{ $root.selectedLanguageData.no }}
                          </b-radio></b-field>
                      </div>
                    </div>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
<!--get tax file number-->
                <div v-if="$root.formData.tax_payer ===`Yes`">
                  <!--                  &&-->
                  <!--                  $root.kycFieldVisibility.politically_exposed-->
                  <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{ $root.selectedLanguageData.enter_the_tax_file_number
                    }}<span class="has-text-danger">*</span>
                  </label>
                  <div class="field">
                    <p class="control has-icons-right">
                      <ValidationProvider name="Position" :rules="{ required: true, }" v-slot="{ errors }">
                        <b-input type="text" @focus="$inputFocused('tax_file_number')"
                                 @input="$inputChanged('tax_file_number')"
                                 @blur="$inputBlured('tax_file_number')"
                                 v-model="$root.formData.tax_file_number" />
                        <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </div>
                </div>
<!--                end tax section-->

<!--                v-if="$root.kycFieldVisibility.politically_exposed"-->
                <div class="field mt-4" >
                  <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{ $root.selectedLanguageData.publicPositionsHeldBySelf
  }}<span class="has-text-danger">*</span></label>
                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <div class="columns">
                      <div class="column is-one-two">
                        <b-field>
                          <b-radio name="Public Position Held By Self" style="font-family: OpenSans-Regular"
                            native-value="Yes" @focus="$inputFocused('politically_exposed')"
                            @input="$inputChanged('politically_exposed')" @blur="$inputBlured('politically_exposed')"
                            v-model="$root.formData.politically_exposed">
                            {{ $root.selectedLanguageData.yes }}
                          </b-radio></b-field>
                      </div>

                      <div class="column is-one-two">
                        <b-field>
                          <b-radio name="PublicPositionsHeldBySelf" style="font-family: OpenSans-Regular"
                            native-value="No" @focus="$inputFocused('politically_exposed')"
                            @input="$inputChanged('politically_exposed')" @blur="$inputBlured('politically_exposed')"
                            v-model="$root.formData.politically_exposed"
                            @click.native="$root.formData.politically_exposed_position=''">
                            {{ $root.selectedLanguageData.no }}
                          </b-radio></b-field>
                      </div>
                    </div>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <!-- this div only for public Positions Held BySelf persons -->
                <div v-if="
                  $root.formData.politically_exposed ===
                  `Yes`
                ">
<!--                  &&-->
<!--                  $root.kycFieldVisibility.politically_exposed-->
                  <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{ $root.selectedLanguageData.then_specify_position
  }}<span class="has-text-danger">*</span>
                  </label>
                  <div class="field">
                    <p class="control has-icons-right">
                      <ValidationProvider name="Specific Position By Self" :rules="{ required: true, notStartsWith: ' ', notEndsWith: ' ', alphaSpaces: true }" v-slot="{ errors }">
                        <b-input type="text" @focus="$inputFocused('politically_exposed_position')"
                          @input="$inputChanged('politically_exposed_position')"
                          @blur="$inputBlured('politically_exposed_position')"
                          v-model="$root.formData.politically_exposed_position" />
                        <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </div>
                </div>
                <!-- Pubic Positions Heldby CloserRelative Or Associate -->
                <div class="field mt-4" >
<!--                  v-if="$root.kycFieldVisibility.politically_exposed_relative"-->
                  <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{
    $root.selectedLanguageData
      .publicPositionsHeldbyCloserRelativeOrAssociate
  }}<span class="has-text-danger">*</span></label>
                  <ValidationProvider name="publicPosition" :rules="{ required: true }" v-slot="{ errors }">
                    <div class="columns">
                      <div class="column is-one-two">
                        <b-field>
                          <b-radio name="PublicPositions" style="font-family: OpenSans-Regular" native-value="Yes"
                            @focus="$inputFocused('politically_exposed_relative')"
                            @input="$inputChanged('politically_exposed_relative')"
                            @blur="$inputBlured('politically_exposed_relative')"
                            v-model="$root.formData.politically_exposed_relative">
                            {{ $root.selectedLanguageData.yes }}
                          </b-radio></b-field>
                      </div>

                      <div class="column is-one-two">
                        <b-field>
                          <b-radio name="PublicPositions" style="font-family: OpenSans-Regular" native-value="No"
                            @focus="$inputFocused('politically_exposed_relative')"
                            @input="$inputChanged('politically_exposed_relative')"
                            @blur="$inputBlured('politically_exposed_relative')"
                            v-model="$root.formData.politically_exposed_relative"
                          @click.native="$root.formData.politically_exposed_relative_position=''">
                            {{ $root.selectedLanguageData.no }}
                          </b-radio></b-field>
                      </div>
                    </div>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!--If Pubic Positions Heldby CloserRelative Or Associate is yes then this field should be visible -->
                <div v-if="
                  $root.formData.politically_exposed_relative === `Yes`
                ">
<!--                  &&-->
<!--                  $root.kycFieldVisibility.politically_exposed_relative-->
                  <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{ $root.selectedLanguageData.name
  }}<span class="has-text-danger">*</span>
                  </label>
                   <div class="field">
                    <p class="control has-icons-right">
                      <ValidationProvider name="Position" :rules="{ required: true, notStartsWith: ' ', notEndsWith: ' ', alphaSpaces: true  }" v-slot="{ errors }">
                        <b-input type="text" @focus="
                          $inputFocused('politically_exposed_relative_position')
                        " @input="
  $inputChanged('politically_exposed_relative_position')
" @blur="
  $inputBlured('politically_exposed_relative_position')
" v-model="$root.formData.politically_exposed_relative_position" />
                        <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </div>
                </div>

<!--                <div class="mt-4"   v-if="$root.formData.politically_exposed_relative === `Yes`-->
<!--                " >-->
<!--                  <label :class="`${$root.selectedLanguage === `ta`-->
<!--                      ? `ta-label`-->
<!--                      : $root.selectedLanguage === `si`-->
<!--                        ? `si-label`-->
<!--                        : ``-->
<!--                    }`">{{ $root.selectedLanguageData.specify_the_designation-->
<!--                    }}<span class="has-text-danger">*</span>-->
<!--                  </label>-->
<!--                  <div class="field">-->
<!--                    <p class="control has-icons-right">-->
<!--                      <ValidationProvider name="Designation" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                        <b-input type="text" @focus="-->
<!--                          $inputFocused('specified_designation')-->
<!--                        " @input="-->
<!--  $inputChanged('specified_designation')-->
<!--" @blur="-->
<!--  $inputBlured('specified_designation')-->
<!--" v-model="$root.formData.specified_designation" />-->
<!--                        <span class="icon is-small is-right">-->
<!--                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />-->
<!--                        </span>-->
<!--                        <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </p>-->
<!--                  </div>-->
<!--                </div>-->

<!--                v-if="-->
<!--                $root.kycFieldVisibility.politically_exposed ||-->
<!--                $root.kycFieldVisibility.politically_exposed_relative-->
<!--                "-->
                <div class="mt-4" style="font-size: 0.9rem; font-family: OpenSans-Medium; color: #636363" >
                  <span class="has-text-danger">*</span>
                  {{ $root.selectedLanguageData.publicPositionsInclude }}
                </div>
              </div>
            </div>

          </transition>

          <transition appear @before-enter="$animations.beforeEnterBelow" @enter="$animations.enterBelow">
            <div class="columns is-centered mb-3">
              <div class="column is-5 is-offset-4 is-flex is-flex-direction-row-reverse">

<!--                :disabled="-->
<!--                invalid ||-->
<!--                ($root.kycFieldVisibility.contact_no_resident-->
<!--                ? !$root.formData.countryCodeForResidentialContactNum-->
<!--                : false) ||-->
<!--                ($root.kycFieldVisibility.contact_no_work-->
<!--                ? !$root.formData.countryCodeForOfficeContactNum-->
<!--                : false) ||-->
<!--                ($root.kycFieldVisibility.politically_exposed_relative-->
<!--                ? !$root.formData.politically_exposed_relative-->
<!--                : false)-->
<!--                "-->
                <b-button :disabled="invalid || disableContinueButton"  :class="`is-primary ${$root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                      ? `continue-button-si`
                      : `continue-button-en`
                  }`"  @click="submitPageInputs(isContinueButtonLoading, 'purpose','account-info' ,'purpose', 1);">{{ $root.selectedLanguageData.continue }}</b-button><!--purpose-->
                <b-button :class="` ${$root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                      ? `back-button-si`
                      : `back-button-en`
                  }`" @click="$router.push('otp')">{{ $root.selectedLanguageData.back }}</b-button>
              </div>
            </div>
          </transition>
        </form>
      </ValidationObserver>


      <GetHelp v-if="false"></GetHelp>
    </div>
  </div>
</template>
<script>
import "../validate.js";
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import {submitPageInputs} from "@/util/util";
// import { faL } from '@fortawesome/free-solid-svg-icons';
export default {
  components: {
    GetHelp,
    Logo,
  },
  data() {
    const today = new Date();
    return {
      search: "",

      countOne: 0,
      countTwo: 0,
      countriesArray: [],
      userCode: "",
      isResidentCountryCodeTouched: false,
      isWorkCountryCodeTouched: false,
      officeCountryCode: "",
      residanceCountryCode: "",
      officeContactNum: "",
      residanceContactNum: "",
      countryCodePhoneList : [],
      selected: null,
      submitPageInputs: submitPageInputs,
      isContinueButtonLoading : false,
      countryCodeArray: [],
      countryIconStringOffice: `fi fi-lk`,
      countryIconStringResidance: `fi fi-lk`,
      countryOfficeCode: "",
      iconStringOffice: "",
      iconStringUs: "",
      isHide: false,
      isShow: false,
      textArea: false,
      maxDate: new Date(),
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()-1),
      isResidanceNumberLocal : false,
      isOfficeNumberLocal : false,
      isOfficeNumberStartWithZero: false,
      isOfficeNumberStartWithZeroLE: false,
      isRecidentNumberStartWithZeroLE: false,
      isResidentNumberStartWithZero: false,
      isLandNumber: true,
      regex: {
        old_nic: /^([0-9]{9}[Xx||Vv])$/,
        passport: /^[0-9A-Za-z]{4,18}$/,
        new_nic: /[0-9]{12}/,
        mobileNumberRule : /^7[0-8][0-9]{7}$/,
        anyNumberRule : /^\d{9}$/
      },
      slWithDC: "",
      myOptions: {
        layout: {
          color: "black",
          backgroundColor: "#c4c4c41a",
          selectedColor: "black",
          selectedBackgroundColor: "#009ec2",
          borderColor: "black",
          fontWeight: "normal",
          fontWeightSelected: "bold",
        },
        size: {
          fontSize: 14,
          height: 2.5,
          // padding: 2,
          width: 13,
        },
        config: {
          delay: 0.2,
          preSelected: `${this.$root.formData.gender ? this.$root.formData.gender : "Male"
            }`,
          disabled: false,
          items: [
            {
              // name: "Male",
              name: this.$root.selectedLanguageData.male,
              value: "Male",
              color: "black",
            },
            {
              name: this.$root.selectedLanguageData.female,
              value: "Female",
              color: "black",
            },
          ],
        },
      },
      // dualCitizenshipTextArea:
      //   this.$root.formData.sriLankan_with_citizenshipCountries.toString(),
      // foreignNationalWithDualCitizenshipTextArea:
      //   this.$root.formData.foreign_national_citizenshipCountries.toString(),
    };
  },
  methods: {


    // splitNic() {
    //   // this.kycFormStore.isNicChange = true;
    //   if (this.$root.formData.customer_nic.length === 10) {
    //     this.$root.formData.idType = "ONIC";
    //   } else {
    //     this.$root.formData.idType = "NNIC";
    //   }
    // },

    getCountyCodeList(){
      try{
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        this.$http
            .post(this.$baseURL + "/getAllCountries", {},{
              headers:{'X-token':kyc_token}
            })
            .then((response) => {
              console.log(response.data.countries);

              this.countryCodeList = response.data.data.countries;
              this.countryCodeList.forEach(country =>{
                this.countryCodePhoneList.push(country.phone)
              })

              this.countryCodeList = response.data.data.countries;

            })

      }catch(err){
        console.log(err)
      }
    },
    // countryCodeLogoFilterOffice(){
    //   console.log('countryCodeLogoFilter --------')
    //   let countryCodeIndex = this.countryCodeList.findIndex(country => country.phone == this.$root.formData.country_code)
    //   console.log('index ---'+this.countryCodeList[countryCodeIndex].code.toLowerCase())
    //   this.countryIconStringOffice = `fi fi-${this.countryCodeList[countryCodeIndex].code.toLowerCase()}`;
    //
    // },
    //
    // countryCodeLogoFilterResidance(){
    //   console.log('countryCodeLogoFilter --------')
    //   let countryCodeIndex = this.countryCodeList.findIndex(country => country.phone == this.$root.formData.country_code)
    //   console.log('index ---'+this.countryCodeList[countryCodeIndex].code.toLowerCase())
    //   this.countryIconStringResidance = `fi fi-${this.countryCodeList[countryCodeIndex].code.toLowerCase()}`;
    //
    // },

    countryCodeLogoFilter(){
      console.log('countryCodeLogoFilter --------')
      let countryCodeIndex = this.countryCodeList.findIndex(country => country.phone == this.$root.formData.officeCountryCode)
      console.log('index ---'+this.countryCodeList[countryCodeIndex].code.toLowerCase())
      this.$root.formData.countryIconStringOffice = `fi fi-${this.countryCodeList[countryCodeIndex].code.toLowerCase()}`;
      return this.countryIconStringOffice;
      // console.log(this.countryIconString);
    },

    residenceCountryCodeLogoFilter(){
      console.log('countryCodeLogoFilter --------')
      let countryCodeIndex = this.countryCodeList.findIndex(country => country.phone == this.$root.formData.residenceCountryCode)
      console.log('index ---'+this.countryCodeList[countryCodeIndex].code.toLowerCase())
      this.$root.formData.countryIconStringResidance = `fi fi-${this.countryCodeList[countryCodeIndex].code.toLowerCase()}`;
      return this.$root.formData.countryIconStringResidance;
      // console.log(this.countryIconString);
    },




    contactOfficeContactNo(){
      this.$root.formData.officeNumber = this.$root.formData.officeCountryCode+this.$root.formData.officeContactNumWithOutCode;
    },

    // calPhoneNumberOffice(){
    //   if(this.$root.formData.residenceCountryCode === "+94"){
    //     const tempMobileNumber = this.$root.formData.mobileNumberWithoutCountryCode.trim();
    //     if (tempMobileNumber[0] === "0") {
    //       this.isMobileNumberStartsWithZero = true;
    //     }
    //     else if (!this.regex.mobileNumberRule.test(this.$root.formData.officeCountryCode)){
    //       this.isLandNumber = true;
    //     }
    //     else {
    //
    //     }
    //   }
    // },



    contactResidanceContactNo(){
      this.$root.formData.residentNumber = this.$root.formData.residenceCountryCode+this.$root.formData.residanceContactNumWithOutCode;
    },

    usPersonReseter(){
      this.$root.formData.us_person_account_numbers = ''
      this.$root.formData.us_person_place_of_birth = ''
      this.$root.formData.us_person_permanent_address_line1 = ''
      this.$root.formData.us_person_permanent_address_line2 = ''
      this.$root.formData.us_person_permanent_address_line3 = ''
      this.$root.formData.us_person_permanent_address_postal_code = ''
      this.$root.formData.us_person_permanent_address_country = ''
      this.$root.formData.us_person_mailing_address_line1 = ''
      this.$root.formData.us_person_mailing_address_line2 = ''
      this.$root.formData.us_person_mailing_address_line3 = ''
      this.$root.formData.us_person_mailing_address_postal_code = ''
      this.$root.formData.us_person_mailing_address_country = ''
      this.$root.formData.us_person_passport_no = ''
      this.$root.formData.us_tel_number = ''
      this.$root.formData.us_person_tax_identification_no = ''
      this.$root.formData.mailing_address_in_us_same_as_permanent_address_in_us = false






    },


    /***
     * This function is used to set changing each gender name according to changing language data
     * @param languageData
     * @returns {*|{layout: {backgroundColor: string, borderColor: string, color: string, selectedBackgroundColor: string, fontWeightSelected: string, selectedColor: string, fontWeight: string}, size: {width: number, fontSize: number, height: number}, config: {delay: number, disabled: boolean, preSelected: string, items: [{color: string, name: *, value: string},{color: string, name: *, value: string}]}}|{layout: {backgroundColor: string, borderColor: string, color: string, selectedBackgroundColor: string, fontWeightSelected: string, selectedColor: string, fontWeight: string}, size: {width: number, fontSize: number, height: number}, config: {delay: number, disabled: boolean, preSelected: string, items: [{color: string, name: string, value: string},{color: string, name: string, value: string}]}}}
     */
    getMyOptions(languageData) {
      const comp = this
      let options = comp.myOptions
      options.config.items[0].name = languageData.male
      options.config.items[1].name = languageData.female

      return options
    },

    removeItem(item) {
      if (this.$root.formData.dual_citizen_countries.includes(item)) {
        this.$root.formData.dual_citizen_countries =
          this.$root.formData.dual_citizen_countries.filter(
            (element) => element !== item
          );
      }
    },
    passportValidateObject() {
      let obj = {
        required: this.$root.formData.us_person === `Yes`,
        notMatchRegex: [this.regex.old_nic, this.regex.new_nic],
        regex: this.regex.passport,
      };
      return obj;
    },
    passportMandotoryValidate(){
      if (this.$root.formData.residentship === "Non Resident"){
        let obj = {
          required: true,
        };
        return obj;
      }
    },

    sameAsPermanentAddress() {
      this.$root.formData.us_person_permanent_address = `${this.$root.formData.permanent_address_line1
        } ${this.$root.formData.permanent_address_line1 ? "," : ""} ${this.$root.formData.permanent_address_line2
        }${this.$root.formData.permanent_address_line2 ? "," : ""}${this.$root.formData.permanent_address_line3
        }${this.$root.formData.permanent_address_line3 ? "," : ""} ${this.$root.formData.permanent_address_postal_code
        }${this.$root.formData.permanent_address_postal_code ? "," : ""}${this.$root.formData.permanent_address_country
        }`;
    },

    passportExpireDateCalculator(){

      if( this.$root.formData.account_holder_passport_issue_date !== ''){
            console.log("this.$root.formData.account_holder_passport_issue_date", this.$root.formData.account_holder_passport_issue_date.getFullYear())
            this.$root.formData.account_holder_passport_expiry_date = new Date(this.$root.formData.account_holder_passport_issue_date.getFullYear()+10, this.$root.formData.account_holder_passport_issue_date.getMonth(), this.$root.formData.account_holder_passport_issue_date.getDate())
      }
    },

    passportDateConverter(){
      console.log("type of issue date begining",typeof this.$root.formData.account_holder_passport_issue_date)
      if(typeof this.$root.formData.account_holder_passport_issue_date == 'string' || typeof this.$root.formData.account_holder_passport_expiry_date == 'string'){
        const passportIssueDate = new Date(this.$root.formData.account_holder_passport_issue_date)
        const passportExpireDate = new Date(this.$root.formData.account_holder_passport_expiry_date)
        this.$root.formData.account_holder_passport_issue_date = passportIssueDate
        this.$root.formData.account_holder_passport_expiry_date = passportExpireDate
        console.log("account_holder_passport_issue_date",this.$root.formData.account_holder_passport_issue_date)
        console.log("account_holder_passport_expire_date",this.$root.formData.account_holder_passport_expiry_date)
        console.log("type of issue date",typeof this.$root.formData.account_holder_passport_issue_date)
      }
    },
    /*passportDateConverter() {
      const issueDate = this.$root.formData.account_holder_passport_issue_date;
      const expireDate = this.$root.formData.account_holder_passport_expiry_date;

      // Check if the dates are strings
      if (typeof issueDate === 'string' || typeof expireDate === 'string') {
        // Convert string dates to Date objects
        const passportIssueDate = new Date(issueDate);
        const passportExpireDate = new Date(expireDate);

        // Check if the conversion was successful
        if (!isNaN(passportIssueDate.getTime()) && !isNaN(passportExpireDate.getTime())) {
          // Update the data properties with formatted date strings
          /!*  this.$root.formData.account_holder_passport_issue_date = passportIssueDate.toLocaleDateString('en-US');
          this.$root.formData.account_holder_passport_expiry_date = passportExpireDate.toLocaleDateString('en-US');*!/
          this.$root.formData.account_holder_passport_issue_date = passportIssueDate;
          this.$root.formData.account_holder_passport_expiry_date = passportExpireDate;

          console.log("account_holder_passport_issue_date", this.$root.formData.account_holder_passport_issue_date);
          console.log("account_holder_passport_expiry_date", this.$root.formData.account_holder_passport_expiry_date);
          console.log("account_holder_passport_expiry_dateeeeeeeeeeeeeee", passportIssueDate);
          console.log("type of issue date", typeof this.$root.formData.account_holder_passport_issue_date);
        } else {
          console.error("Invalid date format");
        }
      }
    },*/
   /* passportDateConverter(){

      this.$root.formData.account_holder_passport_issue_date = new Date("2024-01-03T18:30:00.000Z");

    },*/

    // sameAsPermanentAddressInUs() {
    //   if (this.$root.formData.address_in_us_same_as_permanent_address) {
    //     this.$root.formData.us_person_permanent_address_line1 = this.$root.formData.permanent_address_line1;
    //     this.$root.formData.us_person_permanent_address_line2 = this.$root.formData.permanent_address_line2;
    //     this.$root.formData.us_person_permanent_address_line3 = this.$root.formData.permanent_address_line3;
    //     this.$root.formData.us_person_permanent_address_postal_code = this.$root.formData.permanent_address_postal_code;
    //     this.$root.formData.us_person_permanent_address_country = this.$root.formData.permanent_address_country;
    //   } else {
    //     this.$root.formData.us_person_permanent_address_line1 = "";
    //     this.$root.formData.us_person_permanent_address_line2 = "";
    //     this.$root.formData.us_person_permanent_address_line3  = "";
    //     this.$root.formData.us_person_permanent_address_postal_code = "";
    //     this.$root.formData.us_person_permanent_address_country = "";
    //   }
    //
    // },



    calOfficeNumber(){
      if(this.$root.formData.officeCountryCode === "+94"){
        console.log("LK Mobile number ---------------");
        const tempMobileNumber = this.$root.formData.officeContactNumWithOutCode.trim();
        if (tempMobileNumber[0] === "0"){
          this.isOfficeNumberStartWithZero = true;
          this.isOfficeNumberLocal = false;
          this.isOfficeNumberStartWithZeroLE = false
        }

        else if(!this.regex.anyNumberRule.test(this.$root.formData.officeContactNumWithOutCode) && this.isOfficeNumberStartWithZero ){
          this.isOfficeNumberStartWithZeroLE = true;
          this.isOfficeNumberStartWithZero = false;
          this.isOfficeNumberLocal = false;
        }
        else if(!this.regex.anyNumberRule.test(this.$root.formData.officeContactNumWithOutCode)){
          this.isOfficeNumberLocal = true;
          this.isOfficeNumberStartWithZero = false
          this.isOfficeNumberStartWithZeroLE = false
        }
        else {
          this.isOfficeNumberLocal = false;
          this.isOfficeNumberStartWithZero = false
          this.isOfficeNumberStartWithZeroLE = false

        }
      }

      else{
        this.isOfficeNumberLocal = false;
        this.isOfficeNumberStartWithZero = false;
        this.isOfficeNumberStartWithZeroLE = false;
      }


    },

    calResidanceNumber(){
      if(this.$root.formData.residenceCountryCode === "+94"){
        console.log("LK Mobile number ---------------");
        const tempResidance= this.$root.formData.residanceContactNumWithOutCode.trim();
        if (tempResidance[0] === "0"){
          this.isResidentNumberStartWithZero = true;
          this.isRecidentNumberStartWithZeroLE = false;
          this.isResidanceNumberLocal = false;
        }
        else if(!this.regex.anyNumberRule.test(this.$root.formData.officeContactNumWithOutCode) && this.isResidentNumberStartWithZero ){
          this.isRecidentNumberStartWithZeroLE = true;
          this.isResidanceNumberLocal = false;
          this.isResidentNumberStartWithZero = false
        }
         else if(!this.regex.anyNumberRule.test(this.$root.formData.residanceContactNumWithOutCode)){
          this.isResidanceNumberLocal = true;
          this.isRecidentNumberStartWithZeroLE = false;
          this.isResidentNumberStartWithZero = false
        }

        else {
          this.isResidanceNumberLocal = false;
          this.isResidentNumberStartWithZero = false
          this.isRecidentNumberStartWithZeroLE = false
        }
      }
      else {
        this.isResidanceNumberLocal = false;
        this.isResidentNumberStartWithZero = false
        this.isRecidentNumberStartWithZeroLE = false
      }
    },



    sameAsAbovePassport(){
      if(this.$root.formData.same_passport_number=== true){
            this.$root.formData.us_person_passport_no = this.$root.formData.account_holder_passport_number;
      }
      else {
        this.$root.formData.us_person_passport_no = ""
      }
    },

    mailingAddressSameAsPermanentAddessInUS(){
      if (this.$root.formData.mailing_address_in_us_same_as_permanent_address_in_us) {
        this.$root.formData.us_person_mailing_address_line1 = this.$root.formData.us_person_permanent_address_line1;
        this.$root.formData.us_person_mailing_address_line2 = this.$root.formData.us_person_permanent_address_line2;
        this.$root.formData.us_person_mailing_address_line3 = this.$root.formData.us_person_permanent_address_line3;
        this.$root.formData.us_person_mailing_address_postal_code = this.$root.formData.us_person_permanent_address_postal_code;
        this.$root.formData.us_person_mailing_address_country = this.$root.formData.us_person_permanent_address_country;
      }
      else {
        this.$root.formData.us_person_mailing_address_line1 = "";
        this.$root.formData.us_person_mailing_address_line2 = "";
        this.$root.formData.us_person_mailing_address_line3  = "";
        this.$root.formData.us_person_mailing_address_postal_code = "";
        // this.$root.formData.us_person_permanent_address_country = "";
      }
    },

    sameAsForeignAddress() {
      this.$root.formData.us_person_permanent_address = `${this.$root.formData.foreign_address_line1
        }${this.$root.formData.foreign_address_line1 ? "," : ""}${this.$root.formData.foreign_address_line2
        }${this.$root.formData.foreign_address_line2 ? "," : ""}${this.$root.formData.foreign_address_line3
        }${this.$root.formData.foreign_address_line3 ? "," : ""}${this.$root.formData.foreign_address_postal_code
        }${this.$root.formData.foreign_address_postal_code ? "," : ""}${this.$root.formData.foreign_address_country
        }`;
    },
    permanentAddressChange() {
      this.$root.formData.permanentAddress =
        this.$root.formData.permanentAddressLineOne.trim().replace(/,*$/, "") +
        "," +
        this.$root.formData.permanentAddressLineTwo.trim().replace(/,*$/, "") +
        "," +
        this.$root.formData.permanentAddressLineThree.trim().replace(/,*$/, "");

      // this.$root.formData.permanentAddress = `${this.$root.formData.permanentAddressLineOne.trim()}, ${this.$root.formData.permanentAddressLineTwo.trim()}, ${this.$root.formData.permanentAddressLineThree.trim()}`;
    },

    visible() {
      this.isHide = true;
      this.isResidanceNumberLocal = false;
      this.isResidentNumberStartWithZero = false;
      this.isOfficeNumberLocal = false;
      this.isOfficeNumberStartWithZero =false;
      this.isOfficeNumberStartWithZeroLE =false;
      this.isRecidentNumberStartWithZeroLE =false;

      this.countryOfficeCode = "LK +94";
      this.$root.formData.countryCodeForOfficeContactNum = "+94";
      this.$root.formData.countryCodeForOfficeContactNumTemp = "LK";
      this.$root.formData.contact_no_work = "";
      this.$root.formData.contact_no_resident = "";

    },
    visibleNot() {
      this.isHide = false;
      this.countryOfficeCode = "LK +94";
      this.$root.formData.countryCodeForOfficeContactNum = "+94";
      this.$root.formData.countryCodeForOfficeContactNumTemp = "LK";
      this.$root.formData.contact_no_work = "";
      this.$root.formData.contact_no_resident = "";
      this.isResidanceNumberLocal = false;
      this.isResidentNumberStartWithZero = false;
      this.isOfficeNumberLocal = false;
      this.isOfficeNumberStartWithZero =false;
      this.isOfficeNumberStartWithZeroLE =false;
      this.isRecidentNumberStartWithZeroLE =false;
    },

    contactNumberResidentVisible() {
      this.isShow = true;
      this.$root.formData.countryCodeForOfficeContactNum = "+94";
      this.$root.formData.countryCodeForOfficeContactNumTemp = "LK";
      this.$root.formData.contact_no_work = "";
      this.$root.formData.contact_no_resident = "";
      this.isResidanceNumberLocal = false;
      this.isResidentNumberStartWithZero = false;
      this.isOfficeNumberLocal = false;
      this.isOfficeNumberStartWithZero =false;
      this.isOfficeNumberStartWithZeroLE =false;
      this.isRecidentNumberStartWithZeroLE =false;
    },
    showTextArea() {
      this.textArea = true;
    },

    validateFullName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        customerName: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",


      };
      return obj;
    },

    validateOtherName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",


      };
      return obj;
    },


    countryCodeValidation() {
      let obj = {
        regex : /^\+\d+$/,
        // required: true
      };
      return obj;
    },
    spouseFullName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        includes: " ",
      };
      return obj;
    },

    validateNameWithInitials() {
      const obj = {
        required: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        includes: ".",
      };
      return obj;
    },

    combinedRules() {
      // Call the functions and return them as an array
      return [this.passportValidation, this.passportMandotoryValidate];
    },

    nicValidateObject: function () {
      const comp = this;
      let obj = {
        required: true,
      };

      if (comp.$root.formData.idType === "ONIC") {
        obj.regex = comp.regex.old_nic;
      } else if (comp.$root.formData.idType === "NNIC") {
        obj.regex = comp.regex.new_nic;
      }
      else {
        obj.regex = comp.regex.passport;
      }
      return obj;
    },

    foreignNationalWithDualCitizenshipValidation() {
      const obj = {
        required: true,
        length: 2,
      };
      return obj;
    },

    passportNum_2() {
      if (this.$root.formData.same_as_above_passport_number) {
        this.$root.formData.us_person_passport_no =
          this.$root.formData.customer_passport_no;
      } else {
        this.$root.formData.us_person_passport_no = "";
      }
    },
    mailingAddress() {
      if (this.$root.formData.mailing_address_same_as_permanent_address) {
        this.$root.formData.mailing_address_line1 =
          this.$root.formData.permanent_address_line1;
        this.$root.formData.mailing_address_line2 =
          this.$root.formData.permanent_address_line2;
        this.$root.formData.mailing_address_line3 =
          this.$root.formData.permanent_address_line3;
        this.$root.formData.mailing_address_postal_code =
          this.$root.formData.permanent_address_postal_code;
        this.$root.formData.mailing_address_country =
          this.$root.formData.permanent_address_country;
      } else {
        this.$root.formData.mailing_address_line1 = "";
        this.$root.formData.mailing_address_line2 = "";
        this.$root.formData.mailing_address_line3 = "";
        this.$root.formData.mailing_address_postal_code = "";
        this.$root.formData.mailing_address_country = "";
      }
    },
    contactNumberResidentInvisible() {
      this.isShow = false;
      this.userCode = "LK +94";
      this.$root.formData.countryCodeForResidentialContactNum = "+94";
      this.$root.formData.countryCodeForResidentialContactNumTemp = "LK";
      this.$root.formData.contact_no_work = "";
      this.$root.formData.contact_no_resident = "";
      this.isResidanceNumberLocal = false;
      this.isResidentNumberStartWithZero = false;
      this.isOfficeNumberLocal = false;
      this.isOfficeNumberStartWithZero =false;
      this.isRecidentNumberStartWithZeroLE =false;
    },
    correspondentAddress() {
      if (
        this.$root.formData.correspondent_address_in_us ===
        `Same as Permanent Address`
      ) {
        this.$root.formData.correspondent_address_line1 =
          this.$root.formData.permanent_address_line1;
        this.$root.formData.correspondent_address_line2 =
          this.$root.formData.permanent_address_line2;
        this.$root.formData.correspondent_address_line3 =
          this.$root.formData.permanent_address_line3;
        this.$root.formData.correspondent_address_postal_code =
          this.$root.formData.permanent_address_postal_code;
        this.$root.formData.correspondent_address_country =
          this.$root.formData.permanent_address_country;
      } else if (
        this.$root.formData.correspondent_address_in_us ===
        `Same as Foreign Address`
      ) {
        this.$root.formData.correspondent_address_line1 =
          this.$root.formData.foreign_address_line1;
        this.$root.formData.correspondent_address_line2 =
          this.$root.formData.foreign_address_line2;
        this.$root.formData.correspondent_address_line3 =
          this.$root.formData.foreign_address_line3;
        this.$root.formData.correspondent_address_postal_code =
          this.$root.formData.foreign_address_postal_code;
        this.$root.formData.correspondent_address_country =
          this.$root.formData.foreign_address_country;
      } else {
        this.$root.formData.correspondent_address_line1 = "";
        this.$root.formData.correspondent_address_line2 = "";
        this.$root.formData.correspondent_address_line3 = "";
        this.$root.formData.correspondent_address_postal_code = "";
        this.$root.formData.correspondent_address_country = "";
      }
    },
    nsbAccountNumbersValidation() {
      let obj = {
        // accountNumbersCharacter: true,
        // accountNumbers: true,
        // noDuplicates: true,
        regex: /^\d{12}$/

      };
      return obj;
    },
    passportValidation(){

      let obj = {
        regex: /^[0-9A-Za-z]{4,18}$/,
        required: this.$root.formData.residentship === "Non Resident",
      };
      return obj;
    },

    ssnValidation() {
      const obj = {
        required: true,
        noCharacters: true,
        onlyNumbers: true,
        startsWith: "9",
        length: 9,
      };
      return obj;
    },
    usCountryCodeList() {
      if (this.$root.formData.us_person === `Yes`) {
        this.$root.formData.usTellCountryCode = "US";
        this.changeUsContactNumCountryCode();
      }
    },
    changeResidentialSelection() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
        (countryObject) =>
          // countryObject.phone === this.$root.formData.countryCodeForResidentialContactNum
          countryObject.code === this.$root.formData.countryCodeForResidentialContactNumTemp.split(" ")[0]
      );
      this.$root.formData.resident_country_short_name = `${countryCodeTemp.code} ${countryCodeTemp.phone}`;
      this.countryIconString = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },

    changeOfficeContactNumCountryCode() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
        (countryObject) =>
          // countryObject.phone === this.$root.formData.countryCodeForOfficeContactNum
          countryObject.code === this.$root.formData.countryCodeForOfficeContactNumTemp.split(" ")[0]
      );
      this.$root.formData.office_country_short_name = `${countryCodeTemp.code} ${countryCodeTemp.phone}`;
      this.iconStringOffice = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },
    changeUsContactNumCountryCode() {
      this.iconStringUs = `fi fi-${this.$root.formData.usTellCountryCode.toLowerCase()}`;
    },

    genderChange(){
      if(this.$root.formData.account_name ==="RDB Liya saviya" || this.$root.formData.account_name ==="RDB Liya saviya Plus"){
        this.$root.formData.gender = "Female"
      }
    },

    // calResidentialContactNumber() {
    //   this.$root.formData.contact_no_resident = `${this.$root.formData.countryCodeForResidentialContactNum}${this.$root.formData.residentNumber}`;
    // },
    // calOfficeContactNumber() {
    //   this.$root.formData.contact_no_work = `${this.$root.formData.countryCodeForOfficeContactNum}${this.$root.formData.officeNumber}`;
    // },
    calUsContactNumber() {
      const code = this.$root.formData.countriesList.find(
        (item) => item.code === this.$root.formData.usTellCountryCode
      );
      this.$root.formData.us_person_telephone_no = `${code.phone}${this.$root.formData.us_tel_number}`;
    },
    dualCitizenCounties() {
      this.$root.formData.dual_citizen_countries = [];
    },
    countrySelect(value) {
      this.$root.formData.permanent_address_country = value;
      this.$root.formData.mailing_address_country = value;
      if(this.$root.formData.residentship !== 'Non Resident'){
        this.$root.formData.resident_country = ''
      }

    },
    submitForm: function () {
      let comp = this;
      let bodyFormData = new FormData();
      bodyFormData.append("kyc_branch", comp.$root.formData.branch);
      let kyc_token = comp.$root.formData.kyc_token +'.'+ comp.$root.formData.color_code4 +'.'+ comp.$root.formData.color_code12;
      comp.$http
          .post(comp.$baseURL + "/kycForm/submitAccountInfoKycForm", bodyFormData, {
            headers: { "Content-Type": "multipart/form-data","X-token":kyc_token },
          })
          .then(function (response) {
            //handle success
            console.log("kyc token....",kyc_token)
            console.log("successfully submitted--------------");
            console.log(response);

            comp.isContinueButtonLoading = false;
            comp.$root.isFormSubmitted = true;
            comp.$router.push('purpose')

            /* comp.$router.push("congratulation");*/
          })
          .catch(function (response) {
            //handle error
            console.log(response);
            comp.$buefy.toast.open({
              message: "Failed to submit form data",
              type: "is-danger",
            });
          });
    },
    formatDate(date){
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate()

      if(month < 10){
        month = "0"+month;
      }
      let output = [month,day,year]
      return output.join("/")
    },
    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step_name:'Account Selection',
            last_step: 2,
            form_filled:true,
            next_route:'Employment Info',
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

  },
  computed: {


    // filteredDataArr() {
    //   return this.countryCodeArray.filter((option) => {
    //     return option.toLowerCase().indexOf(this.userCode.toLowerCase()) >= 0;
    //   });
    // },
      disableContinueButton() {
        return this.isOfficeNumberStartWithZeroLE || this.isRecidentNumberStartWithZeroLE || this.isOfficeNumberStartWithZero || this.isOfficeNumberLocal || this.isResidanceNumberLocal || this.isResidentNumberStartWithZero;
      },

    filteredDataArray() {
      return this.countryCodePhoneList.filter((option) => {
        return option
            .toString()
            .toLowerCase()
            .indexOf(this.$root.formData.officeCountryCode.toLowerCase())
      })
    },
    residenceFilteredDataArray() {
      return this.countryCodePhoneList.filter((option) => {
        return option
            .toString()
            .toLowerCase()
            .indexOf(this.$root.formData.residenceCountryCode.toLowerCase())
      })
    },
    filteredCountryDataArr() {
      return this.countryCodeArray.filter((option) => {
        return (
          option.toLowerCase().indexOf(this.countryOfficeCode.toLowerCase()) >=
          0
        );
      });
    },
    
  },

  mounted() {
    // this.updateLastStep();
    this.getCountyCodeList();
    this.genderChange();
    //this.passportDateConverter();



    this.countriesArray = this.$root.selectedLanguageData.countries.filter(
      (item) => item.value !== "Sri Lanka"
    );

    this.usCountryCodeList();

    if (this.$root.formData.customer_nic) {
      let year;
      let genderValue;
      let monthAndDayInDays;
      if (this.$root.formData.customer_nic.length === 10) {
        genderValue = this.$root.formData.customer_nic.slice(2, 5);
        monthAndDayInDays =
          parseInt(genderValue, 10) >= 500
            ? parseInt(genderValue - 500, 10)
            : parseInt(genderValue, 10);
        year = parseInt(
          `19${this.$root.formData.customer_nic.slice(0, 2)}`,
          10
        );
      } else if (this.$root.formData.customer_nic.length === 12) {
        genderValue = this.$root.formData.customer_nic.slice(4, 7);
        monthAndDayInDays =
          parseInt(genderValue, 10) >= 500
            ? parseInt(genderValue - 500, 10)
            : parseInt(genderValue, 10);
        year = parseInt(`${this.$root.formData.customer_nic.slice(0, 4)}`, 10);
      }
      let month;
      let day;
      if (monthAndDayInDays <= 31) {
        month = "01";
        if (monthAndDayInDays < 10) {
          day = `0${monthAndDayInDays}`;
        } else {
          day = monthAndDayInDays;
        }
      } else if (monthAndDayInDays <= 60) {
        month = "02";
        day = monthAndDayInDays - 31;
      } else if (monthAndDayInDays <= 91) {
        month = "03";
        day = monthAndDayInDays - 60;
      } else if (monthAndDayInDays <= 121) {
        month = "04";
        day = monthAndDayInDays - 91;
      } else if (monthAndDayInDays <= 152) {
        month = "05";
        day = monthAndDayInDays - 121;
      } else if (monthAndDayInDays <= 182) {
        month = "06";
        day = monthAndDayInDays - 152;
      } else if (monthAndDayInDays <= 213) {
        month = "07";
        day = monthAndDayInDays - 182;
      } else if (monthAndDayInDays <= 244) {
        month = "08";
        day = monthAndDayInDays - 213;
      } else if (monthAndDayInDays <= 274) {
        month = "09";
        day = monthAndDayInDays - 244;
      } else if (monthAndDayInDays <= 305) {
        month = "10";
        day = monthAndDayInDays - 274;
      } else if (monthAndDayInDays <= 335) {
        month = "11";
        day = monthAndDayInDays - 305;
      } else {
        month = "12";
        day = monthAndDayInDays - 335;
      }
      this.$root.formData.date_of_birth = new Date(
        `${year.toString()}-${month}-${day}`
      );
      // const intGenderValue = parseInt(genderValue, 10);
      // if (intGenderValue >= 500) {
      //   this.$root.formData.gender = "Female";
      // } else {
      //   this.$root.formData.gender = "Male";
      // }
    }
    for (const country of this.$root.formData.countriesList) {
      this.countryCodeArray.push(`${country.code} ${country.phone}`);
    }
    if (!this.$root.formData.countryCodeForResidentialContactNum) {
      this.$root.formData.countryCodeForResidentialContactNum = "+94";
    }
    if (!this.$root.formData.countryCodeForOfficeContactNum) {
      this.$root.formData.countryCodeForOfficeContactNum = "+94";
    }

    if (!this.$root.formData.usTellCountryCode) {
      this.$root.formData.usTellCountryCode = "US";
    }
    if (this.$root.formData.residentNumber) {
      this.isShow = true;
    }
    if (this.$root.formData.officeNumber) {
      this.isHide = true;
    }
    const tempResidentCountryCodeName = this.$root.formData.countriesList.find(
      (country) =>
        // country.phone === this.$root.formData.countryCodeForResidentialContactNum
        country.code === this.$root.formData.countryCodeForResidentialContactNumTemp.split(" ")[0]
    );
    this.userCode = this.countryCodeArray.find(
      (hello) =>
        hello ===
        `${tempResidentCountryCodeName.code} ${this.$root.formData.countryCodeForResidentialContactNum}`
    );
    const tempOfficeCountryCodeName = this.$root.formData.countriesList.find(
      (country) =>
        // country.phone === this.$root.formData.countryCodeForOfficeContactNum
        country.code === this.$root.formData.countryCodeForOfficeContactNumTemp.split(" ")[0]
    );
    this.countryOfficeCode = this.countryCodeArray.find(
      (hello) =>
        hello ===
        `${tempOfficeCountryCodeName.code} ${this.$root.formData.countryCodeForOfficeContactNum}`
    );
    this.changeResidentialSelection();
    this.changeOfficeContactNumCountryCode();
    this.changeUsContactNumCountryCode();



  },
};
</script>
<style>
.background-image3 {
  position: absolute;
  top: 3%;
  left: -10%;

  z-index: -1;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-attachment: fixed;
}
@media only screen and (max-width: 500px) {
  .texthead{
    font-size:2.5rem;
  }
}
</style>
